export const uploadData = [
    {
        "no": "1",
        "dateOfSeizure": "September-2019",
        "nameOfAccused": "Rose Karimi alias Rebecca Karimi",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Nkabune area, Imenti North sub-county",
        "latitude": -1.166392,
        "longitude": 36.825279,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "1 piece of elephant tusk w s/v Ksh 750,000",
        "weight": "7 and 1/2 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "2",
        "dateOfSeizure": "February-2018",
        "nameOfAccused": "Eutichus Mwiti Rigera",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Meru town",
        "latitude": 0.045639,
        "longitude": 37.653004,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 arw 92 WCMA",
        "charge2": "Dealing in wildlife trophy c/s 95 WCMA arw 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "15.1 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2018",
        "nameOfAccused": "Jackline Kanyere Nderitu",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Meru town",
        "latitude": 0.045639,
        "longitude": 37.653004,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 arw 92 WCMA",
        "charge2": "Dealing in wildlife trophy c/s 95 WCMA arw 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "15.1 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "3",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Isaack Kibori Rutere",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nchiru area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "John Murega Mweti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nchiru area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "4",
        "dateOfSeizure": "February-2020",
        "nameOfAccused": "Polycarp Gikunda Ikiungu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mukothima Market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Possession of a specified endangered wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusk",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2020",
        "nameOfAccused": "Nicholas Kirimi Muriuki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mukothima Market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Possession of a specified endangered wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusk",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "5",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Dennis Kaindio",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kariro Village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of an endangered wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks w s/v 1.2m",
        "weight": "1.2 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "6",
        "dateOfSeizure": "September-2021",
        "nameOfAccused": "Aron Mukundi Muthengi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marimanti Township",
        "latitude": 0.918074,
        "longitude": 34.162748,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard, Serval",
        "exhibit": "5 pieces of leopard skin and 1 piece of serval cat skin",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2021",
        "nameOfAccused": "Phillip Musa Matiti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marimanti Township",
        "latitude": 0.918074,
        "longitude": 34.162748,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard, Serval",
        "exhibit": "5 pieces of leopard skin and 1 piece of serval cat skin",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "7",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Elias Njeru Nyaga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kathegeri - Kiangungi road within Embu County",
        "latitude": -1.047967,
        "longitude": 36.885975,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 WCMA",
        "charge2": "Dealing in wildlife trophy c/s 95 WCMA arw 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks w s/v 2.6 m",
        "weight": "26 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Romulas Kaume Mugambi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kathegeri - Kiangungi road within Embu County",
        "latitude": -1.047967,
        "longitude": 36.885975,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 WCMA",
        "charge2": "Dealing in wildlife trophy c/s 95 WCMA arw 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks w s/v 2.6 m",
        "weight": "26 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Zackary Muriithi Njagi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kathegeri - Kiangungi road within Embu County",
        "latitude": -1.047967,
        "longitude": 36.885975,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 WCMA",
        "charge2": "Dealing in wildlife trophy c/s 95 WCMA arw 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks w s/v 2.6 m",
        "weight": "26 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "8",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "John Mwirigi Mutembei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kisima Farm area, Buuri sub-county",
        "latitude": 0.078515,
        "longitude": 37.305855,
        "charge1": "Dealing in wildlife meat w/o a permit c/s 98 (1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "2 bushbuck carcasses",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "9",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "Ian Kaimenyi Alias Milita",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maitei area, Maitei location",
        "latitude": 4.13333,
        "longitude": 37.63333,
        "charge1": "Possession of a specified endangered wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "Dealing in wildlife trophy c/s 95 WCMA arw 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusk",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "Jackline Nkatia Kaaria",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Maitei area, Maitei location",
        "latitude": 4.13333,
        "longitude": 37.63333,
        "charge1": "Possession of a specified endangered wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "Dealing in wildlife trophy c/s 95 WCMA arw 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusk",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "10",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "John Mwirigi Mutembei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kisima Farm area, Buuri sub-county",
        "latitude": 0.078515,
        "longitude": 37.305855,
        "charge1": "Dealing in wildlife meat w/o a permit c/s 98 (1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "2 carcasses",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "11",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Alexius Kooro M'Mwathi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marania Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "3 pieces",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "12",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Edward Mutethia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nchoroiboro forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Orea Africana",
        "exhibit": "9 posts",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Japheth Mugambi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nchoroiboro forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Orea Africana",
        "exhibit": "9 posts",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Lawrence Dereba",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nchoroiboro forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Orea Africana",
        "exhibit": "9 posts",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "13",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Martin Mutwiri Chokera",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Limauru Area within Tigania West",
        "latitude": -0.562101,
        "longitude": 34.934856,
        "charge1": "Dealing in a specified endangered wildlife trophy w/o a permit C/S 92(3) WCMA",
        "charge2": "Being in possession of a specified endangered wildlife trophy w/o a permit C/S 92(4) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks; Govt Vehicle GKA374N",
        "weight": "17kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "14",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Jukwan Lepuyapui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Lorian Village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of wildlife trophy w/o a permit c/s 95 (d) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of tusks",
        "weight": "745 gm",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "15",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "James Gitau Kabaiko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Shabaa area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in endangered species c/s 92 (2) arw 105 (a) and (b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Motorbike reg no. KMEX 643G",
        "weight": "100 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "16",
        "dateOfSeizure": "February-2021",
        "nameOfAccused": "Humphrey Kithinji Mutwiri",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kindani location",
        "latitude": null,
        "longitude": null,
        "charge1": "Cutting and removing forest produce c/s 64 (1) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Milicia Excelsa",
        "exhibit": "1 indigenous tree",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "17",
        "dateOfSeizure": "October-2022",
        "nameOfAccused": "Jane Kabon Elmaindi",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Karandi area",
        "latitude": -3.191485,
        "longitude": 36.985824,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 95 (b) WCMA",
        "charge2": "Possession of wildlife trophy c/s 95",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippo, Waterbuck",
        "exhibit": "2 pieces of hippo tusks; 1 piece of waterbuck horn; 1 warthog tusk w s/v of Kshs 100,000",
        "weight": "1.9 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "18",
        "dateOfSeizure": "July-2021",
        "nameOfAccused": "John Njoroge Kamunye",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mugie Ranch",
        "latitude": -0.335528,
        "longitude": 37.645866,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "300 kgs w s/v of Kshs 210,000",
        "weight": "300 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2021",
        "nameOfAccused": "Joseph Thuo Waithira",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mugie Ranch",
        "latitude": -0.335528,
        "longitude": 37.645866,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "300 kgs w s/v of Kshs 210,000",
        "weight": "300 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "19",
        "dateOfSeizure": "January-2020",
        "nameOfAccused": "Eric Gitau Njoki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gatundia Area",
        "latitude": -0.25,
        "longitude": 36.2833,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "Dealing in WT c/s 92(2) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "27kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "20",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Amos Gitonga Wachira",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nyahururu",
        "latitude": 0.035099,
        "longitude": 36.364204,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 95 (b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "3.675kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Joseph Irungu Mwangi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nyahururu",
        "latitude": 0.035099,
        "longitude": 36.364204,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 95 (b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "3.675kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "21",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Lemoltelei Kiplelan",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "The route Hotel",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "18 pieces of elephant tusks",
        "weight": "41kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Tigon Tidongo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "The route Hotel",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "18 pieces of elephant tusks",
        "weight": "41kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Gabriel Wambugu Kiarie",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "The route Hotel",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "18 pieces of elephant tusks",
        "weight": "41kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "22",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Emmanuel Atunu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Loisaba Conservancy",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Sandalwood, Motorcycles KMFF796R & KMFF798R",
        "weight": "222kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Samuel Nyongesa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Loisaba Conservancy",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Sandalwood, Motorcycles KMFF796R & KMFF798R",
        "weight": "222kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Nickson Igwada",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Loisaba Conservancy",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Sandalwood, Motorcycles KMFF796R & KMFF798R",
        "weight": "222kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "23",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Martin Thuku Kiumbuku",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mpala Ranch",
        "latitude": -1.353303,
        "longitude": 37.455814,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Sandalwood, Motorcycles KMFP339X",
        "weight": "180kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Dismus Etyang Okendi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mpala Ranch",
        "latitude": -1.353303,
        "longitude": 37.455814,
        "charge1": "Possession of wildlife trophy c/s 92 (4) arw 105 (1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Sandalwood, Motorcycles KMFP339X",
        "weight": "180kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "24",
        "dateOfSeizure": "September-2020",
        "nameOfAccused": "David Mwangi Ndegwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Karampton Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy c/s 92(2) WCMA",
        "charge2": "Being in possession of W/T C/S 92(4) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "88kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2020",
        "nameOfAccused": "Peter Mubiri Mukunga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Karampton Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy c/s 92(2) WCMA",
        "charge2": "Being in possession of W/T C/S 92(4) WCMA",
        "charge3": "Failure to comply with a lawful requirement given by an authorized officer c/s 101(a) WCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "88kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "25",
        "dateOfSeizure": "July-2020",
        "nameOfAccused": "Gibson Ziro Shida",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bamba Trading Centre, Bamba Sub-Location, Bamba Division, Ganze sub-county within Kilifi County",
        "latitude": -3.542398,
        "longitude": 39.522316,
        "charge1": "Dealing in wildlife trophy c/s 84 (1) arw Sec 92 WCMA 2013",
        "charge2": "Being in possession of WT without a permit c/s 95 WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of Tusks",
        "weight": "49 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2020",
        "nameOfAccused": "Peter Komora Guyo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bamba Trading Centre, Bamba Sub-Location, Bamba Division, Ganze sub-county within Kilifi County",
        "latitude": -3.542398,
        "longitude": 39.522316,
        "charge1": "Dealing in wildlife trophy c/s 84 (1) arw Sec 92 WCMA 2013",
        "charge2": "Being in possession of WT without a permit c/s 95 WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of Tusks",
        "weight": "49 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "26",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Darusi Zira Mwalimu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kijangwani area within Kilifi County within Coast region",
        "latitude": -3.7833,
        "longitude": 39.8333,
        "charge1": "Dealing in meat of wildlife species without permit orother lawful exemption c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sea Turtle",
        "exhibit": "Meat, plastic bucket",
        "weight": "11.10 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "24",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Pascal Mwaiha Katana",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mingujini area of Ganze sub-countywithin Kilifi County",
        "latitude": -3.544051,
        "longitude": 39.69252,
        "charge1": "Being in possession of wildlife trophy of endangered species without permit or other lawful exemption c/s 92(4) of the WCMA 2013 (As Amended)",
        "charge2": "Dealing in a WT of endangered species without permit or other lawful exemption c/s 92 (2) of the WCMA 2013 (As Amended)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "10 cut pieces of tusks",
        "weight": "14 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Daniel Kasiwa Kalu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mingujini area of Ganze sub-countywithin Kilifi County",
        "latitude": -3.544051,
        "longitude": 39.69252,
        "charge1": "Being in possession of wildlife trophy of endangered species without permit or other lawful exemption c/s 92(4) of the WCMA 2013 (As Amended)",
        "charge2": "Dealing in a WT of endangered species without permit or other lawful exemption c/s 92 (2) of the WCMA 2013 (As Amended)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "10 cut pieces of tusks",
        "weight": "14 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "28",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Jumaa Chengo Kitsao",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mrima wa ndege location in Ganze Sub-county within Kilifi County",
        "latitude": -3.544051,
        "longitude": 39.69252,
        "charge1": "Dealing in wildlife trophy of a suspected endangered species without permit or other lawful exemption c/s 92(2) of the WCMA 2013",
        "charge2": "Being in possession of a suspected endangered WT without a permit or other lawful exemption c/s 92(4) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks, sack",
        "weight": "8 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Charo Kupata Nzae",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mrima wa ndege location in Ganze Sub-county within Kilifi County",
        "latitude": -3.544051,
        "longitude": 39.69252,
        "charge1": "Dealing in wildlife trophy of a suspected endangered species without permit or other lawful exemption c/s 92(2) of the WCMA 2013",
        "charge2": "Being in possession of a suspected endangered WT without a permit or other lawful exemption c/s 92(4) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks, sack",
        "weight": "8 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "29",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Denis Kaindio",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Being in possession of an endangered wildlife trophy w/o permit c/s 92(4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks",
        "weight": "1.2 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "30",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Boniface Elijah M'Kiara",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibaranya Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rosewood",
        "exhibit": "2 logs",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "31",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Nicholas Mutuiri",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mucheene Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cypress",
        "exhibit": "14 pieces of logs",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "32",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Daniel Mutai Musonik",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Meru National Park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Stealing by servant c/s 281 of the penal code",
        "charge2": "Dealing in WT c/s 92(2) of WCMA",
        "charge3": "Neglect of official duties c/s 128 arw 36 of the penal code",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "Neglect of official duties c/s 128 arw 36 of the penal code",
        "alternativeCharge3": "Neglect of official duties c/s 128 arw 36 of the penal code",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "33",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Jeff Owino Omondi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sabache area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy w/o permit c/s 95(d) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "Skull",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "34",
        "dateOfSeizure": "February-2021",
        "nameOfAccused": "Abdullahi Dida",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Choma Hotel",
        "latitude": 2.4333,
        "longitude": 38.05,
        "charge1": "Possession of live wildlife species c/s 95(d) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Tortoise",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "35",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Nahason Gitonga Gikamati",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "78area within Isiolo County",
        "latitude": 0.35,
        "longitude": 37.583303,
        "charge1": "Possession of endangered wildlife trophy w/o permit c/s 92(4) arw 105 WCMA",
        "charge2": "Dealing in wildlife trophy of an endangered species c/s 92(2) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "7.12 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Ezra Muliuki Kairi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "78area within Isiolo County",
        "latitude": 0.35,
        "longitude": 37.583303,
        "charge1": "Possession of endangered wildlife trophy w/o permit c/s 92(4) arw 105 WCMA",
        "charge2": "Dealing in wildlife trophy of an endangered species c/s 92(2) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "7.12 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "36",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Andrew Kayuyu Kuya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kiwanja area",
        "latitude": -4.420232,
        "longitude": 38.308198,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "200 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "37",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Lopunu Leparmarai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sera Conservancy",
        "latitude": -4.595344,
        "longitude": 35.734558,
        "charge1": "Killing of wildlife species c/s 95 (a) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Oryx",
        "exhibit": "FN Rifle No. A113903",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "38",
        "dateOfSeizure": "July-2020",
        "nameOfAccused": "Dapson Saitoti Kilua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngaresirkon",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of endangered wildlife trophy w/o permit c/s 92(4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "3 pieces of elephant tusks",
        "weight": "3.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2020",
        "nameOfAccused": "Jenet Parkusaa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngaresirkon",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of endangered wildlife trophy w/o permit c/s 92(4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "3 pieces of elephant tusks",
        "weight": "3.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2020",
        "nameOfAccused": "Lperere Kalaile Kilua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngaresirkon",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of endangered wildlife trophy w/o permit c/s 92(4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "3 pieces of elephant tusks",
        "weight": "3.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "39",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Ltaiya Lekirienyei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Morongori area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of endangered wildlife trophy w/o permit c/s 92(4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "1 piece of elephant tusk",
        "weight": "2.18 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "40",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Anthony Mutuku Kimweli",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olmayia area in Mashuru sub-county",
        "latitude": -2.101496,
        "longitude": 37.128361,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Wildlife Meat",
        "weight": "180 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Patrick Mwololo John",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olmayia area in Mashuru sub-county",
        "latitude": -2.101496,
        "longitude": 37.128361,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Wildlife Meat",
        "weight": "180 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "41",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Hannah Wambui Njuguna",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Bisil Township",
        "latitude": 0.918074,
        "longitude": 34.162748,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Antelope",
        "exhibit": "Wildlife Meat",
        "weight": "40 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "42",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "John Wanjala Nyongesa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bisil Township",
        "latitude": 0.918074,
        "longitude": 34.162748,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gazelle",
        "exhibit": "Wildlife Meat",
        "weight": "30 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Patrick Mutunga Mutua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bisil Township",
        "latitude": 0.918074,
        "longitude": 34.162748,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gazelle",
        "exhibit": "Wildlife Meat",
        "weight": "30 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "43",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Patrick Saisi Mushila",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kajiado-Mashuuru road",
        "latitude": -2.101496,
        "longitude": 37.128361,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Duiker Antelope",
        "exhibit": "One full carcass",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Danile Kingoo Kimwake",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kajiado-Mashuuru road",
        "latitude": -2.101496,
        "longitude": 37.128361,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Duiker Antelope",
        "exhibit": "One full carcass",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "44",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Pantelo Saa Kanelo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ilishoni area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Wildlife meat; 3 Manilla sacks green in color; Motorcycle Reg No. KMDM 345B",
        "weight": "200 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "45",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Joseph Lesirat",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ilbisil town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Dealing in an endangered wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lion",
        "exhibit": "Lion claws",
        "weight": "100 gms",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "46",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Edwin Mokaya Nyandega",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Namanga Town",
        "latitude": -2.55024,
        "longitude": 36.785703,
        "charge1": "Dealing in live wildlife species c/s 95(c) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Grey Crowned Crane ",
        "exhibit": "2 Birds",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "47",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Ndambuki Mutie",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ilbisil town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) WCMA",
        "charge2": "Dealing in trophy of wildlife species c/s 95(b) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala, Antelope, Dik-dik, Zebra",
        "exhibit": "Wildlife meat; Skin",
        "weight": "34 kgs; 10.30 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "48",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Faustine Swalei",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Lorbeta area",
        "latitude": 2.492829,
        "longitude": 33.911789,
        "charge1": "Dealing in meat of wildlife species w/o a permit c/s 98(1) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "Carcass",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "49",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "John Nyabuto Mosago",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mogunga Town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Possession of wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Four pieces of elephant tusks",
        "weight": "26.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Andrew Maina Maenda",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mogunga Town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Possession of wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Four pieces of elephant tusks",
        "weight": "26.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Henry Nyabuto Ongaki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mogunga Town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Possession of wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Four pieces of elephant tusks",
        "weight": "26.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Peter Babu Onduso",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mogunga Town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Possession of wildlife trophy c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Four pieces of elephant tusks",
        "weight": "26.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "50",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Joseph Nguro Kabiru",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kijabe area, Lari sub-county",
        "latitude": -1.053442,
        "longitude": 36.630875,
        "charge1": "Conspiracy to commit a felony c/s 393 PC",
        "charge2": "Possession of endangered wildlife trophy c/s 92 (4) arw 105 (1)(b)WCMA",
        "charge3": "Dealing in endangered wildlife trophy c/s 92(2) arw 105(1)(b)WCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Motor vehicle reg no. KCW 432H",
        "weight": "537.60 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Morris Maina Njuguna",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nairobi City",
        "latitude": -1.283253,
        "longitude": 36.817245,
        "charge1": "Conspiracy to commit a felony c/s 393 PC",
        "charge2": "Dealing in endangered wildlife trophy c/s 92(2) arw 105(1)(b)WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "537.60 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Mutua Mwangangi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nairobi City",
        "latitude": -1.283253,
        "longitude": 36.817245,
        "charge1": "Conspiracy to commit a felony c/s 393 PC",
        "charge2": "Dealing in endangered wildlife trophy c/s 92(2) arw 105(1)(b)WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "537.60 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Agnes Nene Nasieku",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Nairobi City",
        "latitude": -1.283253,
        "longitude": 36.817245,
        "charge1": "Conspiracy to commit a felony c/s 393 PC",
        "charge2": "Dealing in endangered wildlife trophy c/s 92(2) arw 105(1)(b)WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "537.60 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "51",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Isaac Mugwandia Macharia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Joska area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy c/s 92(4) WCMA",
        "charge2": "Possession of ammunition c/s 4(2)(a) arw 4(3)(a) Firearms Act",
        "charge3": "Forgery c/s 345 arw 349 PC",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "1 piece of elephant tusk",
        "weight": "1 kg",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "52",
        "dateOfSeizure": "October-2022",
        "nameOfAccused": "Annah Ekai Lopuwa",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Soloikan Guest House in Kakuma Town",
        "latitude": 3.707747,
        "longitude": 34.864635,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "6 pieces of elephant tusks, 2 elephant jaws, and 1 leopard skin",
        "weight": "32.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2022",
        "nameOfAccused": "Dorcas Mugure",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Soloikan Guest House in Kakuma Town",
        "latitude": 3.707747,
        "longitude": 34.864635,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "6 pieces of elephant tusks, 2 elephant jaws, and 1 leopard skin",
        "weight": "32.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "53",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Samuel Ndungu Thuku",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Wamba-Rumuruti road",
        "latitude": 0.978216,
        "longitude": 37.323975,
        "charge1": "Possession of wildlife trophy c/s 92(4) WCMA",
        "charge2": "Conspiracy to commit a felony c/s 393 PC",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Two motorcycles Reg No.s KMFT 660Z & KMFV 708B",
        "weight": "395.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Samuel Wamai Wamuhu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Wamba-Rumuruti road",
        "latitude": 0.978216,
        "longitude": 37.323975,
        "charge1": "Possession of wildlife trophy c/s 92(4) WCMA",
        "charge2": "Conspiracy to commit a felony c/s 393 PC",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Two motorcycles Reg No.s KMFT 660Z & KMFV 708B",
        "weight": "395.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Daniel Macharia Gachaku",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Wamba-Rumuruti road",
        "latitude": 0.978216,
        "longitude": 37.323975,
        "charge1": "Possession of wildlife trophy c/s 92(4) WCMA",
        "charge2": "Conspiracy to commit a felony c/s 393 PC",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Two motorcycles Reg No.s KMFT 660Z & KMFV 708B",
        "weight": "395.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "54",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Johakim Losikiria Labolia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Baragoi area",
        "latitude": 1.7833,
        "longitude": 36.7833,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) arw 105(1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Toyota Land Cruiser reg. No. KBP 896V and KCB 034Y",
        "weight": "1500 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Thomas Achuka Lokwatuba",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Baragoi area",
        "latitude": 1.7833,
        "longitude": 36.7833,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) arw 105(1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Toyota Land Cruiser reg. No. KBP 896V and KCB 034Y",
        "weight": "1500 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Kelly Echapan Labolia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Baragoi area",
        "latitude": 1.7833,
        "longitude": 36.7833,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) arw 105(1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Toyota Land Cruiser reg. No. KBP 896V and KCB 034Y",
        "weight": "1500 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Francis Edal Nadiko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Baragoi area",
        "latitude": 1.7833,
        "longitude": 36.7833,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) arw 105(1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Toyota Land Cruiser reg. No. KBP 896V and KCB 034Y",
        "weight": "1500 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "John Muiruri Kanyi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Baragoi area",
        "latitude": 1.7833,
        "longitude": 36.7833,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) arw 105(1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Toyota Land Cruiser reg. No. KBP 896V and KCB 034Y",
        "weight": "1500 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "55",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Edward Mwambura Kamau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kangari market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "19 pieces of elephant tusks",
        "weight": "62 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Peter Macharia Njuguna",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kangari market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "19 pieces of elephant tusks",
        "weight": "62 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Martin Mungai Nginya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kangari market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "19 pieces of elephant tusks",
        "weight": "62 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Samuel Njuguna Mwirigi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kangari market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "19 pieces of elephant tusks",
        "weight": "62 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "56",
        "dateOfSeizure": "August-2021",
        "nameOfAccused": "Albanus Kioko Musyoki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Devkie and Mlolongo",
        "latitude": -1.394789,
        "longitude": 36.94039,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "1 piece of elephant tusk",
        "weight": "1.545 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2021",
        "nameOfAccused": "Albanus Kioko Peter",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Devkie and Mlolongo",
        "latitude": -1.394789,
        "longitude": 36.94039,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "1 piece of elephant tusk",
        "weight": "1.545 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "57",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "John Adongo Nyilima",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ruaka",
        "latitude": -1.206819,
        "longitude": 36.785915,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of raw elephant tusks and 13 pieces of worked ivories",
        "weight": "10.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Hamisy Nambande Kassim",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ruaka",
        "latitude": -1.206819,
        "longitude": 36.785915,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of raw elephant tusks and 13 pieces of worked ivories",
        "weight": "10.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Alex Wanjau Ndichu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ruaka",
        "latitude": -1.206819,
        "longitude": 36.785915,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of raw elephant tusks and 13 pieces of worked ivories",
        "weight": "10.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Amos Saisi Mbakulu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ruaka",
        "latitude": -1.206819,
        "longitude": 36.785915,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of raw elephant tusks and 13 pieces of worked ivories",
        "weight": "10.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "58",
        "dateOfSeizure": "July-2021",
        "nameOfAccused": "Beth Wambui Waithira",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Athi River area",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Dealing in wildlife trophy w/o a permit c/s 92(2) arw 105(1)(b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "Toyota Ractis KCT 654R",
        "weight": "300.15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "59",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Faiz Mohammed Miji",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwasasi area in Lamu Central",
        "latitude": -1.288877,
        "longitude": 36.836036,
        "charge1": "Possession of wildlife trophy c/s 95(d) WCMA",
        "charge2": "Dealing in carcasses or meat of wildlife species c/s 98(1) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "Buffalo head",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Isaac Irungu Kogi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwasasi area in Lamu Central",
        "latitude": -1.288877,
        "longitude": 36.836036,
        "charge1": "Possession of wildlife trophy c/s 95(d) WCMA",
        "charge2": "Dealing in carcasses or meat of wildlife species c/s 98(1) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "Buffalo head",
        "weight": "N/A",
        "judgmentDate": 44746,
        "judgmentOutcome": "Convicted",
        "sentencing": "2 yrs probation",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "George Kingi Kenga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwasasi area in Lamu Central",
        "latitude": -1.288877,
        "longitude": 36.836036,
        "charge1": "Possession of wildlife trophy c/s 95(d) WCMA",
        "charge2": "Dealing in carcasses or meat of wildlife species c/s 98(1) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "Buffalo head",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Shadad Fadhil Kombo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwasasi area in Lamu Central",
        "latitude": -1.288877,
        "longitude": 36.836036,
        "charge1": "Possession of wildlife trophy c/s 95(d) WCMA",
        "charge2": "Dealing in carcasses or meat of wildlife species c/s 98(1) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "Buffalo head",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "60",
        "dateOfSeizure": "October-2020",
        "nameOfAccused": "Ali Bakari Shelali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mkanda channel of Lamu West",
        "latitude": -2.26754,
        "longitude": 40.901064,
        "charge1": "Transporting forest produce w/o a valid licence c/s Reg 11(1)(a) arw Reg 27 Forest Harvesting Rules 2009",
        "charge2": "Operating vessel w/o navigation lights c/Reg 8(2)(c) arw 34(1) Merchant Shipping (Small Vessel Safety) Regulation 2012 Legal Notice No. 114",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Mangrove Timber",
        "exhibit": "40 pieces",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2020",
        "nameOfAccused": "Bausi Athman Bausi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mkanda channel of Lamu West",
        "latitude": -2.26754,
        "longitude": 40.901064,
        "charge1": "Transporting forest produce w/o a valid licence c/s Reg 11(1)(a) arw Reg 27 Forest Harvesting Rules 2009",
        "charge2": "Operating vessel w/o navigation lights c/Reg 8(2)(c) arw 34(1) Merchant Shipping (Small Vessel Safety) Regulation 2012 Legal Notice No. 114",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Mangrove Timber",
        "exhibit": "40 pieces",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "61",
        "dateOfSeizure": "December-2022",
        "nameOfAccused": "Sila Maluku Geoffrey",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mto- Mawe- Portland area",
        "latitude": -3.426559,
        "longitude": 35.81459,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Zebra meat, zebra liver, zebra skin, zebra head, 2 pangas, 2 slashers, 3 big game wire snares, 3 bows, 5 arrows, 1 arrow casing, 1 axe",
        "weight": "16 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2022",
        "nameOfAccused": "Geoffrey Maingu Itumo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mto- Mawe- Portland area",
        "latitude": -3.426559,
        "longitude": 35.81459,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Zebra meat, zebra liver, zebra skin, zebra head, 2 pangas, 2 slashers, 3 big game wire snares, 3 bows, 5 arrows, 1 arrow casing, 1 axe",
        "weight": "16 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "62",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Ken Felix Walala",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Saba saba area within Mombasa County",
        "latitude": -0.140751,
        "longitude": 39.329042,
        "charge1": "Dealing in wildlife trophy of an endangered species w/o a permit c/s 92(2) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "5 pieces of elephant tusks",
        "weight": "10 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Martin Arogo Ayieko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Saba saba area within Mombasa County",
        "latitude": -0.140751,
        "longitude": 39.329042,
        "charge1": "Dealing in wildlife trophy of an endangered species w/o a permit c/s 92(2) arw 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "5 pieces of elephant tusks",
        "weight": "10 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "63",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Kofa Hamisi Hero",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Haroresa road area, Haroresa sub-location, Subaki locationGalole sub-county within Tana River County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98(1) of WCMA 2013",
        "charge2": "Killing a wildlife species without permit or other lawful exemption c/s 95 (a) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "14 Dik dik carcass, BM-100 Bajaj Boxer Motorcycle reg. no. KMFX 787X",
        "weight": "28 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "64",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Katana Charo Malunja",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Hara area, Hara sub-location, Ngwano location, Galole sub-county within Tana river County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Engaging in hunting for purpose of subsitence c/s 97 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Guinea fowl",
        "exhibit": "1 Carcass",
        "weight": "1.5 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Njoma Said Dzivo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Hara area, Hara sub-location, Ngwano location, Galole sub-county within Tana river County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Engaging in hunting for purpose of subsitence c/s 97 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Guinea fowl",
        "exhibit": "1 Carcass",
        "weight": "1.5 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "65",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Omar Maro Dae",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kumbi village in Tana River sub-county within Tana River county",
        "latitude": -1.2833,
        "longitude": 40,
        "charge1": "Possession of game meat c/s 98 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "Meat",
        "weight": "9 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "66",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Bakari Said",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Dashumali area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98(1) as read with 105(1)(b) of WCMA 2013",
        "charge2": "Killing a wildlife species without permit or other lawful exemption c/s 95 (a) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Black Sandgrouse bird",
        "exhibit": "10 Dik dik carcass, 1 Black Sandrouuse bird, 3 panga, improvised hooting horns, 1 slasher, 1 torch, 2 manila sacks, 2 jerricans, 3 motorcycle (Blue Bajaj boxer reg. no. KMFU 878A, Red Bajaj boxer reg. no. KMFA 345X, Red bajaj reg. no. KMEM 398W)",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Mkamba Said Barisa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Dashumali area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98(1) as read with 105(1)(b) of WCMA 2013",
        "charge2": "Killing a wildlife species without permit or other lawful exemption c/s 95 (a) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Black Sandgrouse bird",
        "exhibit": "10 Dik dik carcass, 1 Black Sandrouuse bird, 3 panga, improvised hooting horns, 1 slasher, 1 torch, 2 manila sacks, 2 jerricans, 3 motorcycle (Blue Bajaj boxer reg. no. KMFU 878A, Red Bajaj boxer reg. no. KMFA 345X, Red bajaj reg. no. KMEM 398W)",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Risheni Idi Ali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Dashumali area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98(1) as read with 105(1)(b) of WCMA 2013",
        "charge2": "Killing a wildlife species without permit or other lawful exemption c/s 95 (a) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Black Sandgrouse bird",
        "exhibit": "10 Dik dik carcass, 1 Black Sandrouuse bird, 3 panga, improvised hooting horns, 1 slasher, 1 torch, 2 manila sacks, 2 jerricans, 3 motorcycle (Blue Bajaj boxer reg. no. KMFU 878A, Red Bajaj boxer reg. no. KMFA 345X, Red bajaj reg. no. KMEM 398W)",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "67",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Said Komora Jiilo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gururi area, Harorest sub=location, Galole sub-county within Tana River County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Being in possession of meat of wildlife species without a permit c/s 98(1) of the WCMA 2018",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, porcupine, Lesser Kudu",
        "exhibit": "23 Dik dik carcass, porcupine meat, Lesser Kudu meat, Red Bajaj boxer - BM 100 Motorcycle reg. no KMDX 173H, Red Bajaj boxer - BM 100 Motorcycle reg. no KMEV 563N, Red Bajaj boxer - BM 100 Motorcycle reg. no KMFQ 423P, Red Bajaj boxer - BM 100 Motorcycle reg. no KMDT 424P",
        "weight": "54 Kgs Dik dik, 14 Kgs porcupine, 60 Kgs Lesser Kudu",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Omar Sake Boride",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gururi area, Harorest sub=location, Galole sub-county within Tana River County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Being in possession of meat of wildlife species without a permit c/s 98(1) of the WCMA 2018",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, porcupine, Lesser Kudu",
        "exhibit": "23 Dik dik carcass, porcupine meat, Lesser Kudu meat, Red Bajaj boxer - BM 100 Motorcycle reg. no KMDX 173H, Red Bajaj boxer - BM 100 Motorcycle reg. no KMEV 563N, Red Bajaj boxer - BM 100 Motorcycle reg. no KMFQ 423P, Red Bajaj boxer - BM 100 Motorcycle reg. no KMDT 424P",
        "weight": "54 Kgs Dik dik, 14 Kgs porcupine, 60 Kgs Lesser Kudu",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Omar Ware Bakari",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gururi area, Harorest sub=location, Galole sub-county within Tana River County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Being in possession of meat of wildlife species without a permit c/s 98(1) of the WCMA 2018",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, porcupine, Lesser Kudu",
        "exhibit": "23 Dik dik carcass, porcupine meat, Lesser Kudu meat, Red Bajaj boxer - BM 100 Motorcycle reg. no KMDX 173H, Red Bajaj boxer - BM 100 Motorcycle reg. no KMEV 563N, Red Bajaj boxer - BM 100 Motorcycle reg. no KMFQ 423P, Red Bajaj boxer - BM 100 Motorcycle reg. no KMDT 424P",
        "weight": "54 Kgs Dik dik, 14 Kgs porcupine, 60 Kgs Lesser Kudu",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "68",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Omar Adan Sugo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Godia area in Tana North sub-county within Tana River County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Being possession of meat of wildlife species without a permit c/s 98 (1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk",
        "exhibit": "8 Dik dik carcass, 1 Gerenuk carcass",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "69",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Ioris Maulid Guyo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Godia area in Tana North sub-county within Tana River County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Being possession of meat of wildlife species without a permit c/s 98 (1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk",
        "exhibit": "8 Dik dik carcass, 1 Gerenuk carcass",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "70",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Issack Osman Kurosofi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Godia area in Tana North sub-county within Tana River County",
        "latitude": -1.497681,
        "longitude": 40.034911,
        "charge1": "Being in possession of meat of wildlife species without a permit c/s 98(1) of the WCMA 2018",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk",
        "exhibit": "8 Dik dik carcass, 1 Gerenuk carcass",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "91",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "James Chapman Natir",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Pazuri Hotel in Kitale town within Trans Nzoia County",
        "latitude": 0.836494,
        "longitude": 35.120007,
        "charge1": "Dealing in wildlife trophy of a critically endangered species without a permit or other lawful exemption c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "Being in possession of WT of critically endangered species without a permit or other lawful exemption c/s 92(4) WCMA 2013",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "2 pieces of horns",
        "weight": "0.48 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Joshua Natir",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Pazuri Hotel in Kitale town within Trans Nzoia County",
        "latitude": 0.836494,
        "longitude": 35.120007,
        "charge1": "Dealing in wildlife trophy of a critically endangered species without a permit or other lawful exemption c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "Being in possession of WT of critically endangered species without a permit or other lawful exemption c/s 92(4) WCMA 2014",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "2 pieces of horns",
        "weight": "0.48 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Ali Kipkemboi Kogo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Pazuri Hotel in Kitale town within Trans Nzoia County",
        "latitude": 0.836494,
        "longitude": 35.120007,
        "charge1": "Dealing in wildlife trophy of a critically endangered species without a permit or other lawful exemption c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "Being in possession of WT of critically endangered species without a permit or other lawful exemption c/s 92(4) WCMA 2015",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "2 pieces of horns",
        "weight": "0.48 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "92",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Mwangangi Chabari Nyaga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Blue Ocean Lodge near Tseikuru Secondary School, Tseikuru sub-county within Kitui county",
        "latitude": -0.307487,
        "longitude": 38.21902,
        "charge1": "Dealing in wildlife trophy c/s 92(2) arw 105 (1) (a) WCMA 2013",
        "charge2": "Being in possession of WT c/s 92 (4) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant, Leopard, Cheetah, Python",
        "exhibit": "7 pieces of Elephant tusks, 2 Leopard Skin, 1 cheetah skin, 1 python skin, Black Motor cycle reg. no. KMFD 418V of makr Ranger",
        "weight": "33 kgs tusks",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Eliud Mwaniki Kaura",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Blue Ocean Lodge near Tseikuru Secondary School, Tseikuru sub-county within Kitui county",
        "latitude": -0.307487,
        "longitude": 38.21902,
        "charge1": "Dealing in wildlife trophy c/s 92(2) arw 105 (1) (a) WCMA 2013",
        "charge2": "Being in possession of WT c/s 92 (4) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant, Leopard, Cheetah, Python",
        "exhibit": "7 pieces of Elephant tusks, 2 Leopard Skin, 1 cheetah skin, 1 python skin, Black Motor cycle reg. no. KMFD 418V of makr Ranger",
        "weight": "33 kgs tusks",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "93",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Ahmed Isaak",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kakunguu Village, Masungwa Location, Tseikuru Sub-County within Kitui County",
        "latitude": -0.307487,
        "longitude": 38.21902,
        "charge1": "Dealing in wildlife trophy of endangered species without permit or other lawful exemption c/s 92(2) arw section 105 WCMA 2013",
        "charge2": "Being in possession of WT of endangered species without a permit or other lawful exception c/s 92 (4) arw Section 105 WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks, Blue Motor cycle reg. no. KMET 736Y of make Shineray",
        "weight": "35.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Daniel Muthui Kimwele",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kakunguu Village, Masungwa Location, Tseikuru Sub-County within Kitui County",
        "latitude": -0.307487,
        "longitude": 38.21902,
        "charge1": "Dealing in wildlife trophy of endangered species without permit or other lawful exemption c/s 92(2) arw section 105 WCMA 2013",
        "charge2": "Being in possession of WT of endangered species without a permit or other lawful exception c/s 92 (4) arw Section 105 WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks, Blue Motor cycle reg. no. KMET 736Y of make Shineray",
        "weight": "35.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "94",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Pius Kamandi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ulu wildlife Conservancy",
        "latitude": -1.812356,
        "longitude": 37.146451,
        "charge1": "Killing a specified endangered wildlife species without a permit or other lawful exemption c/s 92(a) WCMA 2013 as amended in Jan. 2019",
        "charge2": "Dealing in Carcass of wildlife species c/s 98(1) of WCMA 2013 as ammmended in Jan. 2019",
        "charge3": "Conveying hunting apparatus into a protected area c/s 102(f) of WCMA 2013 as amended in Jan 2019.",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rock Python, Dik-dik",
        "exhibit": "11 ft python carcass, 3 Dik dik carcass, 8 bows, 18 arows",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "95",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Mutua Mutaki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Vota area in Kalama Sub-County within Machakos County",
        "latitude": -1.521248,
        "longitude": 37.266088,
        "charge1": "Dealing in meat of a wildlife species without a permit or tother lawful exemtion c/s 98(1) of the WCMA 2013 as amended in Jan. 2019",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "meat, nylon shopping bag",
        "weight": "2 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "96",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Januaries Ndolo Kimeu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kyumbi area in Mavoko sub-county within Machakos County",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Dealing in meat of a wildlife species without a permit or tother lawful exemtion c/s 98(1) of the WCMA 2013.",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wildebeest",
        "exhibit": "approx. 20 kgs meat, yellow bucket, Motorcycle reg. no. KMFF 903K, 1 knife, 1 blood stained manila sack, approx. 1/4Kg of cooked wildbeest meat, 1 pink cup with soup, 2 plates to serve the cooked meat",
        "weight": "Approx. 20 Kgs raw meat, approx. 1/4 cooked meat",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Jack Makite Kimweyi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kyumbi area in Mavoko sub-county within Machakos County",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Dealing in meat of a wildlife species without a permit or tother lawful exemtion c/s 98(1) of the WCMA 2013.",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wildebeest",
        "exhibit": "approx. 20 kgs meat, yellow bucket, Motorcycle reg. no. KMFF 903K, 1 knife, 1 blood stained manila sack, approx. 1/4Kg of cooked wildbeest meat, 1 pink cup with soup, 2 plates to serve the cooked meat",
        "weight": "Approx. 20 Kgs raw meat, approx. 1/4 cooked meat",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Clintone Otieno Ochieng",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kyumbi area in Mavoko sub-county within Machakos County",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Dealing in meat of a wildlife species without a permit or tother lawful exemtion c/s 98(1) of the WCMA 2013.",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wildebeest",
        "exhibit": "approx. 20 kgs meat, yellow bucket, Motorcycle reg. no. KMFF 903K, 1 knife, 1 blood stained manila sack, approx. 1/4Kg of cooked wildbeest meat, 1 pink cup with soup, 2 plates to serve the cooked meat",
        "weight": "Approx. 20 Kgs raw meat, approx. 1/4 cooked meat",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "97",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Jeremiah Muendo Simon",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Malili Shopping Centre within Makueni County",
        "latitude": -0.850348,
        "longitude": 36.147324,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wildebeest",
        "exhibit": "meat, Skin, Manila Paper, 1 green sack. 13 snares, 2 Kitchen knives, 1 pange, Blue Sonlink Motorcycle reg. no. KMEF 834S, Blue Skygo motor cyclr reg. no. KMFT 502M",
        "weight": "Approx. 100 Kgs meat",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "98",
        "dateOfSeizure": "October-2020",
        "nameOfAccused": "David Muia Maina",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Malaa area within Machakos County",
        "latitude": 0.3017,
        "longitude": 34.623585,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Thompson Gazelle",
        "exhibit": "Head, liver, staffed intestine, 25 kgs green sack, simba cement bag, green basin,",
        "weight": "4 kgs meat (approx.)",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2020",
        "nameOfAccused": "Francisca Mueni Kiio",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Malaa area within Machakos County",
        "latitude": 0.3017,
        "longitude": 34.623585,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Thompson Gazelle",
        "exhibit": "Head, liver, staffed intestine, 25 kgs green sack, simba cement bag, green basin,",
        "weight": "4 kgs meat (approx.)",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "99",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Kelvin Mwendwa Matata",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nzoiyani-Muthwani Area within Machakos Sub-county within Machakos County",
        "latitude": -1.51968,
        "longitude": 37.26727,
        "charge1": "Dealing in meat of a wildlife trophy c/s 98(1) WCMA as amended in Jan 2019.",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Heartbeast, Grant Gazelle, Wildebeest",
        "exhibit": "1 Heartbeast, 1 Grant Gazelle limb, 1 Wildebeest limb, 3 snares, 1 blood stained sufuria, 1 blood stained knife",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Kelvin Mwanzia Nzisa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nzoiyani-Muthwani Area within Machakos Sub-county within Machakos County",
        "latitude": -1.51968,
        "longitude": 37.26727,
        "charge1": "Dealing in meat of a wildlife trophy c/s 98(1) WCMA as amended in Jan 2019.",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Heartbeast, Grant Gazelle, Wildebeest",
        "exhibit": "1 Heartbeast, 1 Grant Gazelle limb, 1 Wildebeest limb, 3 snares, 1 blood stained sufuria, 1 blood stained knife",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Timothy Nzesya Mutiso",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nzoiyani-Muthwani Area within Machakos Sub-county within Machakos County",
        "latitude": -1.51968,
        "longitude": 37.26727,
        "charge1": "Dealing in meat of a wildlife trophy c/s 98(1) WCMA as amended in Jan 2019.",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Heartbeast, Grant Gazelle, Wildebeest",
        "exhibit": "1 Heartbeast, 1 Grant Gazelle limb, 1 Wildebeest limb, 3 snares, 1 blood stained sufuria, 1 blood stained knife",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Dennis Ngovi Mulwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nzoiyani-Muthwani Area within Machakos Sub-county within Machakos County",
        "latitude": -1.51968,
        "longitude": 37.26727,
        "charge1": "Dealing in meat of a wildlife trophy c/s 98(1) WCMA as amended in Jan 2019.",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Heartbeast, Grant Gazelle, Wildebeest",
        "exhibit": "1 Heartbeast, 1 Grant Gazelle limb, 1 Wildebeest limb, 3 snares, 1 blood stained sufuria, 1 blood stained knife",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "100",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Benson Mulwa Musyoki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Komarock Village in Matungulu sub-county within Machakos County",
        "latitude": -1.282108,
        "longitude": 37.281784,
        "charge1": "Dealing with meat of a wildlife species without a permit or other lawful exemption c/s 98(1) WCMA2013 as ammended in Jan 2019",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "Meat, Manila shopping bag",
        "weight": "Approx. 6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "101",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Amos Muli Kioko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Vota area in Kalama Sub-County within Machakos County",
        "latitude": -1.521248,
        "longitude": 37.266088,
        "charge1": "Dealing with meat of a wildlife species without a permit or other lawful exemption c/s 98(1) WCMA2013 as ammended in Jan 2019",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "raw meat, cooked meat",
        "weight": "2 kgs raw meat, 2 kgs cooked meat",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "102",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Kimanthi Mwanthi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kyumbi area in Mavoko sub-county within Machakos County",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Dealing with meat of a wildlife species without a permit or other lawful exemption c/s 98(1) WCMA 2013 as ammended in Jan 2019",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Heart beast",
        "exhibit": "1 head, 2 blood stained nylon sacks, 1 blood stained knife",
        "weight": "20 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Munyao Kiswili",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kyumbi area in Mavoko sub-county within Machakos County",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Dealing with meat of a wildlife species without a permit or other lawful exemption c/s 98(1) WCMA 2013 as ammended in Jan 2019",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Heart beast",
        "exhibit": "1 head, 2 blood stained nylon sacks, 1 blood stained knife",
        "weight": "20 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Wambua Matheka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kyumbi area in Mavoko sub-county within Machakos County",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Dealing with meat of a wildlife species without a permit or other lawful exemption c/s 98(1) WCMA 2013 as ammended in Jan 2019",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Heart beast",
        "exhibit": "1 head, 2 blood stained nylon sacks, 1 blood stained knife",
        "weight": "20 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "103",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Jinja Jira Chigunda",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kanani area in Jacaranda within Malindi sub-county in Kilifi",
        "latitude": -3.21464,
        "longitude": 40.117455,
        "charge1": "Killing specified endangered wildlife species without a permit c/s 92 species of the WCMA 2013",
        "charge2": "Being in possession of a specified endangered wildlife species without a permit c/s 92 (4) WCMA 2013",
        "charge3": "Conveying a weapon into protected area c/s 102(f) of WCMA 2013",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Turtle ",
        "exhibit": "Carcass, Spear Gun",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "104",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Eric Sulubu Mwanzongi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tank L area in Galana within Kilifi County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in carcasses of wildlife species c/s to section 98(1) WCMA 2013 (2018)",
        "charge2": "Killing of wildlife species c/s 95(1) arw Section 105 of the WCMA 2013 (2018)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk, Bustard bird, Hare",
        "exhibit": "31 pieces Dik dik, 2 pieces Gerenuk, 1 Bustard bird, 1 hare, GPS Coordinates 37M 0555787, UTM 9600377, 1 Panga, 2 sirens , 1 torch , Motor bike reg. no. KMFQ 778Z",
        "weight": "98 kgs Dik dik, 25 Kgs Gerenuk",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "105",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Mzungu Kadzenga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Madunguni (kwa Majoka) area, Malindi sub-county within Kilifi County",
        "latitude": -3.1833,
        "longitude": 39.9833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) arw Section 105 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "24 pieces, Motor cycle reg no. KMGA 830T",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Mvera Safari",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Madunguni (kwa Majoka) area, Malindi sub-county within Kilifi County",
        "latitude": -3.1833,
        "longitude": 39.9833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) arw Section 105 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "24 pieces, Motor cycle reg no. KMGA 830T",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "106",
        "dateOfSeizure": "November-2022",
        "nameOfAccused": "Moses Iha Katana",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Lali Hills area in Galana Ranch area in Kilifi County",
        "latitude": -3.6333,
        "longitude": 39.85,
        "charge1": "Dealing in carcasses of wildlife species c/s to section 98(1) WCMA 2019",
        "charge2": "Killing of wildlife species c/s 95(1) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Hare",
        "exhibit": "6 Dik dik carcasses, 1 hare, 1 panga, 1 siren, 1 torch, Motor cycle reg. no. KMFM 591N, GPS Coordinates 37M 0532448 UTM 9668893",
        "weight": "Approx. 50 Kgs Dik dik carcasses",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "107",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Jonathan Fraha",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilifi County",
        "latitude": -3.6333,
        "longitude": 39.85,
        "charge1": "Dealing in carcasses of wildlife species c/s to section 98(1) arw section 105 WCMA 2013 (2018)",
        "charge2": "Killing of wildlife species c/s 95(1) arw Section 105 (1)(A) of the WCMA 2013 (2018)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Porcupine",
        "exhibit": "59 pieces of Dik dik, 1 piece of porcupine, GPS Coordinates 37M 0549399 UTM 9682017",
        "weight": "177 Kgs Dik dik carcass",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "108",
        "dateOfSeizure": "August-2021",
        "nameOfAccused": "Benson Jefwa Kalama",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mida - Bandacho area inside Arabuko Sokoke forest wihin Kilifi County",
        "latitude": -3.540365,
        "longitude": 39.820525,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Suni Antelope",
        "exhibit": "4 carcasses",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "109",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Samson Mweri Jefwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilifi County",
        "latitude": -3.6333,
        "longitude": 39.85,
        "charge1": "Dealing in wildlife trophy of an endangered species c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "5 pieces of tusks",
        "weight": "21 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Karisa Kilemba Mboro",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilifi County",
        "latitude": -3.6333,
        "longitude": 39.85,
        "charge1": "Dealing in wildlife trophy of an endangered species c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "5 pieces of tusks",
        "weight": "21 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Kazungu Katana Samwel",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilifi County",
        "latitude": -3.6333,
        "longitude": 39.85,
        "charge1": "Dealing in wildlife trophy of an endangered species c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "5 pieces of tusks",
        "weight": "21 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "110",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Dadu Kalume Shida",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kapangani airstrip area Galana Ranch within Kilifi County",
        "latitude": -2.4166,
        "longitude": 37.9833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk, Gunea Fowl, Bastard Birds",
        "exhibit": "48 Dik dik, 3 Gerenuk, 1 Gunea Fowl, 3 Bastard Birds, GPS Coordinates 37M 0564317 UTM 9689152, 2 Pangas, 2 Torches, 5 Sacks, 2 sirens, 2 jerricans, Boxer Motorcycle reg. no. KMFQ 972P, red TBS motorcycle reg. no. KMFQ 563C, 2 sivana",
        "weight": "192 kgs of Dik dik,81 Kgs of Gerenuk, 6 kgs Gunea Fowl, 6 kgs Bastard Birds",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Elvis Japhet Kazungu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kapangani airstrip area Galana Ranch within Kilifi County",
        "latitude": -2.4166,
        "longitude": 37.9833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk, Gunea Fowl, Bastard Birds",
        "exhibit": "48 Dik dik, 3 Gerenuk, 1 Gunea Fowl, 3 Bastard Birds, GPS Coordinates 37M 0564317 UTM 9689152, 2 Pangas, 2 Torches, 5 Sacks, 2 sirens, 2 jerricans, Boxer Motorcycle reg. no. KMFQ 972P, red TBS motorcycle reg. no. KMFQ 563C, 2 sivana",
        "weight": "192 kgs of Dik dik,81 Kgs of Gerenuk, 6 kgs Gunea Fowl, 6 kgs Bastard Birds",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "111",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Charles Randu Mwalimu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Biress area Galana within Kilifi County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Killing wildlife species without a permit c/s 92 (a) of the WCMA 2013",
        "charge2": "Dealing in the carcass of wildlife species c/s 98(1) of the WCMA 2013(2018)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Lesser Kudu, Bustard Bird",
        "exhibit": "Pieces of Dik dik, pieces of lesser Kudu, 1 panga, 1 siren, GPS Coordinates 37M 0575878, UTM 9705554, Motor bike reg. no. KMFQ 870L",
        "weight": "37 Kgs Dik dik, 40 kgs lesser Kudu",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Furaha Silas Jeffa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Biress area Galana within Kilifi County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Killing wildlife species without a permit c/s 92 (a) of the WCMA 2013",
        "charge2": "Dealing in the carcass of wildlife species c/s 98(1) of the WCMA 2013(2018)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Lesser Kudu, Bustard Bird",
        "exhibit": "Pieces of Dik dik, pieces of lesser Kudu, 1 panga, 1 siren, GPS Coordinates 37M 0575878, UTM 9705554, Motor bike reg. no. KMFQ 870L",
        "weight": "37 Kgs Dik dik, 40 kgs lesser Kudu",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "112",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Rashid Kingi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Total Filling Station area, in Malindi town within Kilifi County",
        "latitude": -3.21464,
        "longitude": 40.117455,
        "charge1": "Dealing in a wildlife trophy of an endangered species without a permit or other lawful exemptions c/s 92(2) of WCMA 2013",
        "charge2": "Dealing in the meat of WT an endangered species without permit or other lawful exemption c/s 98(1) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Turtle ",
        "exhibit": "Meat",
        "weight": "3 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Tingali Ngumbao",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Total Filling Station area, in Malindi town within Kilifi County",
        "latitude": -3.21464,
        "longitude": 40.117455,
        "charge1": "Dealing in a wildlife trophy of an endangered species without a permit or other lawful exemptions c/s 92(2) of WCMA 2013",
        "charge2": "Dealing in the meat of WT an endangered species without permit or other lawful exemption c/s 98(1) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Turtle ",
        "exhibit": "Meat",
        "weight": "3 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "113",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Nickson Kombe Yeri",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Geoffrey Dam area within Kilifi County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in Carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "Killing of wildlife species c/s 95 (1) arw section 105 (1)(a) contrary of WCMA 2013",
        "charge3": "Dealing in carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "charge4": "Killing of wildlife species c/s 95(1) arw 105(1)(a) c/s 2013",
        "charge5": "Dealing in carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "alternativeCharge1": "Killing of wildlife species c/s 95(1) arw section 105 (1)(a) contrary to WCMA 2013",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk, Lesser Kudu, Warthog, Bustard birds",
        "exhibit": "157 pieces Dik dik, 3 pieces Gerenuk, 2 Lesser Kudu,1 Warthog,2 pieces hare, 3 Bustard birds, 10 pangas, 15 sirens, 12 torches, 8 motorbikes registration numbers KMFN 306D, KMFV 392X, KMFH 558R, KMFN 995A, KMFG 418U, KMFT 068S, KMFC 215Q, KMEN 104L",
        "weight": "503 Kgs Dik dik,75 Kgs Gerenuk, 47 Kgs Lesser Kudu, 60 Kgs warthog",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Mbera Kazungu Karisa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Geoffrey Dam area within Kilifi County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in Carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "Killing of wildlife species c/s 95 (1) arw section 105 (1)(a) contrary of WCMA 2013",
        "charge3": "Dealing in carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "charge4": "Killing of wildlife species c/s 95(1) arw 105(1)(a) c/s 2013",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk, Lesser Kudu, Warthog, Bustard birds",
        "exhibit": "157 pieces Dik dik, 3 pieces Gerenuk, 2 Lesser Kudu,1 Warthog,2 pieces hare, 3 Bustard birds, 10 pangas, 15 sirens, 12 torches, 8 motorbikes registration numbers KMFN 306D, KMFV 392X, KMFH 558R, KMFN 995A, KMFG 418U, KMFT 068S, KMFC 215Q, KMEN 104L",
        "weight": "503 Kgs Dik dik,75 Kgs Gerenuk, 47 Kgs Lesser Kudu, 60 Kgs warthog",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Hussein Bashora Komora",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Geoffrey Dam area within Kilifi County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in Carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "Killing of wildlife species c/s 95 (1) arw section 105 (1)(a) contrary of WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk, Lesser Kudu, Warthog, Bustard birds",
        "exhibit": "157 pieces Dik dik, 3 pieces Gerenuk, 2 Lesser Kudu,1 Warthog,2 pieces hare, 3 Bustard birds, 10 pangas, 15 sirens, 12 torches, 8 motorbikes registration numbers KMFN 306D, KMFV 392X, KMFH 558R, KMFN 995A, KMFG 418U, KMFT 068S, KMFC 215Q, KMEN 104L",
        "weight": "503 Kgs Dik dik,75 Kgs Gerenuk, 47 Kgs Lesser Kudu, 60 Kgs warthog",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Naftali Godana Ngonyo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Geoffrey Dam area within Kilifi County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in Carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "Killing of wildlife species c/s 95 (1) arw section 105 (1)(a) contrary of WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "Dealing in carcasses of wildlife species c/s 98 (1) WCMA 2013",
        "alternativeCharge1": "Killing of wildlife species c/s 95(1) arw section 105 (1)(a) contrary to WCMA 2013",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Gerenuk, Lesser Kudu, Warthog, Bustard birds",
        "exhibit": "157 pieces Dik dik, 3 pieces Gerenuk, 2 Lesser Kudu,1 Warthog,2 pieces hare, 3 Bustard birds, 10 pangas, 15 sirens, 12 torches, 8 motorbikes registration numbers KMFN 306D, KMFV 392X, KMFH 558R, KMFN 995A, KMFG 418U, KMFT 068S, KMFC 215Q, KMEN 104L",
        "weight": "503 Kgs Dik dik,75 Kgs Gerenuk, 47 Kgs Lesser Kudu, 60 Kgs warthog",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "114",
        "dateOfSeizure": "February-2021",
        "nameOfAccused": "Bakari Ayub",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Mayungu Fish Shop, in Malindi town within Kilifi County",
        "latitude": -3.21464,
        "longitude": 40.117455,
        "charge1": "Dealing in a wildlife trophy of an endangered species without a permit or other lawful exemptions c/s 92(2) of WCMA 2013",
        "charge2": "Being unlwafully present in kenya c/s 53 (1) (j) arw Section 53 (2) Kenya citizenship and immigration act 20111",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Turtle ",
        "exhibit": "19 pieces of meat",
        "weight": "38 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "115",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Fondo Kea Karisa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Shirango Conservancy within Kilifi county",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog, Porcupine",
        "exhibit": "17 pieces of Warthog, 12 pieces of Porcupine, 1 panga, 1 sack, a bicycle, GPS coordinates 37M 0525703 UTM 9614942",
        "weight": "24 kgs porcupine",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "116",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Chachu Ali Mamu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kambi Nyoka area of North Horr Sub-County within Marsabit County",
        "latitude": 3.321682,
        "longitude": 37.070624,
        "charge1": "Dealing in the meat of a wildlife species c/s 98(1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gazelle",
        "exhibit": "Meat",
        "weight": "30 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Adano Roba Huka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kambi Nyoka area of North Horr Sub-County within Marsabit County",
        "latitude": 3.321682,
        "longitude": 37.070624,
        "charge1": "Dealing in the meat of a wildlife species c/s 98(1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gazelle",
        "exhibit": "Meat",
        "weight": "30 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Mamo Biba Doti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kambi Nyoka area of North Horr Sub-County within Marsabit County",
        "latitude": 3.321682,
        "longitude": 37.070624,
        "charge1": "Dealing in the meat of a wildlife species c/s 98(1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gazelle",
        "exhibit": "Meat",
        "weight": "30 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "117",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Adano Jasro Galgalo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Shurr area of North Horr sub-county within Marsabit County",
        "latitude": 3.321682,
        "longitude": 37.070624,
        "charge1": "Dealing in the carcass or meat of a wildlife species c/s 98(1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gazelle",
        "exhibit": "Meat",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "118",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Abdihakim Ali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sibiloi National Park, Marsabit County",
        "latitude": 2.3378,
        "longitude": 38.013706,
        "charge1": "Being in possession of wildlife trophy c/s 95 WCMA 2013",
        "charge2": "Illegal entry into a National Park c/s 102(1)(a) of WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Nile Perch",
        "exhibit": "25 Nile Perch",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "119",
        "dateOfSeizure": "March-2020",
        "nameOfAccused": "James Legalorah Layane",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Laisamis area within Marsabit County",
        "latitude": 1.58974,
        "longitude": 37.802376,
        "charge1": "Dealing in wildlife trophy of specified endangered species without permit or other lawful exceptions c/s 92(2) ARW Section 105 WCMA 2013",
        "charge2": "Possession in WT of specified endangered species without permit or other lawful exceptions c/s 92(4) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "6 pieces of Tusks, Red Dayun Motorcycle reg. no. KMFD 146M",
        "weight": "44.9 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2020",
        "nameOfAccused": "Lesarian Lejir",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Laisamis area within Marsabit County",
        "latitude": 1.58974,
        "longitude": 37.802376,
        "charge1": "Dealing in wildlife trophy of specified endangered species without permit or other lawful exceptions c/s 92(2) ARW Section 105 WCMA 2013",
        "charge2": "Possession in WT of specified endangered species without permit or other lawful exceptions c/s 92(4) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "6 pieces of Tusks, Red Dayun Motorcycle reg. no. KMFD 146M",
        "weight": "44.9 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "120",
        "dateOfSeizure": "December-2022",
        "nameOfAccused": "Benard Kingodu Kusinga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kasala sub-location Tsavo East National Park in Ikutha sub-county within Kitui County",
        "latitude": -2.1333,
        "longitude": 38.2666,
        "charge1": "Enganging in hunting for the purpose of subsistance c/s 97 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "2 carcasses, 46 snares",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "121",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Paul Nyamai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mutomo area, Mutomo location in Mutomo sub-county within Kitui County",
        "latitude": -1.8471,
        "longitude": 38.20789,
        "charge1": "Being in possession of wildlife trophy C/S 95 (d) WCMA 2013",
        "charge2": "Dealing in a WT without a permit or other lawful exception c/s 95 (b) of WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 tusks",
        "weight": "25 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "122",
        "dateOfSeizure": "February-2021",
        "nameOfAccused": "John Kitovu Matuku",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Simisi area in Kanziku location of Ikutha sub-county within Kitui County",
        "latitude": -2.066139,
        "longitude": 38.1779,
        "charge1": "Being in possession of meat of wildlife species c/s 98 (1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Guinea fowl",
        "exhibit": "Carcass",
        "weight": "12 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "123",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Lars Mwangangi Muthui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kona Kaliti area of South Kitui National Reserve, Mutha Location in Mutomo Sub-county within Kitui County",
        "latitude": -1.365965,
        "longitude": 38.008972,
        "charge1": "Being in possession of wildlife trophy C/S 95 (d) WCMA 2013",
        "charge2": "Having in possession suspected stolen property c/s 323 of the Penal Code",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "12 pieces of Tusks, Bajaj motorcycle reg. no. KMDP 380A",
        "weight": "93.4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Ismael Dame Dadu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kona Kaliti area of South Kitui National Reserve, Mutha Location in Mutomo Sub-county within Kitui County",
        "latitude": -1.365965,
        "longitude": 38.008972,
        "charge1": "Being in possession of wildlife trophy C/S 95 (d) WCMA 2013",
        "charge2": "Having in possession suspected stolen property c/s 323 of the Penal Code",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "12 pieces of Tusks, Bajaj motorcycle reg. no. KMDP 380A",
        "weight": "93.4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "124",
        "dateOfSeizure": "December-2022",
        "nameOfAccused": "Joshua Kasomi Kimwele",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kalambani shopping center, Mutha location in Mutomo sub-county within Kitui County",
        "latitude": -1.797059,
        "longitude": 38.43281,
        "charge1": "Being in possession of an endangered wildlife trophy without permit c/s 92(4) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of tusks",
        "weight": "24 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "125",
        "dateOfSeizure": "December-2022",
        "nameOfAccused": "Samuel Maswali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ithumba Tsavo East National Park at Kalovoto area In Ikutha sub-county within Kitui County.",
        "latitude": -2.195745,
        "longitude": 38.398262,
        "charge1": "Dealing in carcass or meat of wildlife trophy c/s 98(1) WCMA 2013",
        "charge2": "Entering into a National Park c/s 102(1)(a) of WCMA 2013",
        "charge3": "Possession of weapons into a protected c/s 102(f) of WCMA 2013",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Porcupine, Dik-dik Guiniefowl",
        "exhibit": "1 Porcupine, 2 Dik dik 3 Guiniefowl, 3 snares (wires), 2 pairs of rope, 10 dry cells, 2 rolls of poisons, 2 motorcycles",
        "weight": "5 Kgs Porcupine, 3 Kgs Dik dik 1/2 kgsGuiniefowl",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Mutati Nzioka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ithumba Tsavo East National Park at Kalovoto area In Ikutha sub-county within Kitui County.",
        "latitude": -2.195745,
        "longitude": 38.398262,
        "charge1": "Dealing in carcass or meat of wildlife trophy c/s 98(1) WCMA 2013",
        "charge2": "Entering into a National Park c/s 102(1)(a) of WCMA 2013",
        "charge3": "Possession of weapons into a protected c/s 102(f) of WCMA 2013",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Porcupine, Dik-dik Guiniefowl",
        "exhibit": "1 Porcupine, 2 Dik dik 3 Guiniefowl, 3 snares (wires), 2 pairs of rope, 10 dry cells, 2 rolls of poisons, 2 motorcycles",
        "weight": "5 Kgs Porcupine, 3 Kgs Dik dik 1/2 kgsGuiniefowl",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "126",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Musyoki James Mangati",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Athi/Galana River of Tsavo East National Park in Msongaleni location, Ikutha sub-county within Kitui County",
        "latitude": -1.929383,
        "longitude": 38.037426,
        "charge1": "Killing a wildlife without permit or other lawful exemption c/s 95(a) WCMA 2013",
        "charge2": "Entering into a protected area without licence or permit c/s 102(1)(a) of WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Crocodile",
        "exhibit": "1 carcass",
        "weight": "N/A",
        "judgmentDate": "5/30/2022",
        "judgmentOutcome": "Convicted",
        "sentencing": "1 year probation",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Thomas Mutie",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Athi/Galana River of Tsavo East National Park in Msongaleni location, Ikutha sub-county within Kitui County",
        "latitude": -1.929383,
        "longitude": 38.037426,
        "charge1": "Killing a wildlife without permit or other lawful exemption c/s 95(a) WCMA 2013",
        "charge2": "Entering into a protected area without licence or permit c/s 102(1)(a) of WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Crocodile",
        "exhibit": "1 carcass",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "127",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "Issa Mohamed Abdi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kathioko area along Nairobi-Garrisa road within Kitui County",
        "latitude": -1.3666,
        "longitude": 38.0166,
        "charge1": "Dealing in wildlife trophy without a permit c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "2 pieces of horn, M/V reg. no. KCZ 260L",
        "weight": "7.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "Hassan Mohamed Haji",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kathioko area along Nairobi-Garrisa road within Kitui County",
        "latitude": -1.3666,
        "longitude": 38.0166,
        "charge1": "Dealing in wildlife trophy without a permit c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "2 pieces of horn, M/V reg. no. KCZ 260L",
        "weight": "7.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "Sadiq Abdirashid Hassan",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kathioko area along Nairobi-Garrisa road within Kitui County",
        "latitude": -1.3666,
        "longitude": 38.0166,
        "charge1": "Dealing in wildlife trophy without a permit c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "2 pieces of horn, M/V reg. no. KCZ 260L",
        "weight": "7.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "Anis Abdinur Issack",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kathioko area along Nairobi-Garrisa road within Kitui County",
        "latitude": -1.3666,
        "longitude": 38.0166,
        "charge1": "Dealing in wildlife trophy without a permit c/s 92(2) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "2 pieces of horn, M/V reg. no. KCZ 260L",
        "weight": "7.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "128",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Daniel Godana Dacha",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bondeni area in Mangu within Taita Taveta County",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "Pieces of meat, stomach offal, 1 hoof",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Pascal Mwambula Mchambala",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bondeni area in Mangu within Taita Taveta County",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "Pieces of meat, stomach offal, 1 hoof",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "129",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "Dennis Mwakio Mwawughanga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Timboni, Wanjala mines area of Kishushe within Taita Taveta county",
        "latitude": -3.282402,
        "longitude": 38.300674,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "126 pieces of meat",
        "weight": "190 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2021",
        "nameOfAccused": "David Nyambu Maghanga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Timboni, Wanjala mines area of Kishushe within Taita Taveta county",
        "latitude": -3.282402,
        "longitude": 38.300674,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "126 pieces of meat",
        "weight": "190 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "130",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Daniel Godana Dacha",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bondeni area in Mangu within Taita Taveta County",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "Pieces of meat, stomach offal, 1 hoof",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Pascal Mwambula Mchambala",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bondeni area in Mangu within Taita Taveta County",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "Pieces of meat, stomach offal, 1 hoof",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Justine Melle Ali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bondeni area in Mangu within Taita Taveta County",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "Pieces of meat, stomach offal, 1 hoof",
        "weight": "40 Kgs",
        "judgmentDate": "9/21/2022",
        "judgmentOutcome": "Convicted",
        "sentencing": "3 years imprisonment",
        "caseStatus": "Concluded"
    },
    {
        "no": "131",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Joseph Mwandaro Mwandali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tank 9 of Kabanga ranch within Taita Taveta County",
        "latitude": -3.4,
        "longitude": 37.6833,
        "charge1": "Dealing in carcasses of wildlife trophy c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala, Dik-dik",
        "exhibit": "1 impala carcass, 5 dik dik carcass, 2 slasher, 2 torches 1 siren, 1 panga",
        "weight": "23 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "136",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Benson Mwambuwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Lumo Conservancy area within Taita Taveta County",
        "latitude": -3.4,
        "longitude": 37.6833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013 (Revised 2018)",
        "charge2": "Conveying hunting apparatus into a protected area c/s 102(1)(f) arw Section 102 (1) (h) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "Meat, Manila sack, GPS Coordinates 37M 0409428 UTM 9617353",
        "weight": "3 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Harrison Mwasi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Lumo Conservancy area within Taita Taveta County",
        "latitude": -3.4,
        "longitude": 37.6833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013 (Revised 2018)",
        "charge2": "Conveying hunting apparatus into a protected area c/s 102(1)(f) arw Section 102 (1) (h) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "Meat, Manila sack, GPS Coordinates 37M 0409428 UTM 9617353",
        "weight": "3 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Euticus Moto",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Lumo Conservancy area within Taita Taveta County",
        "latitude": -3.4,
        "longitude": 37.6833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013 (Revised 2018)",
        "charge2": "Conveying hunting apparatus into a protected area c/s 102(1)(f) arw Section 102 (1) (h) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "Meat, Manila sack, GPS Coordinates 37M 0409428 UTM 9617353",
        "weight": "3 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Linus Tole",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Lumo Conservancy area within Taita Taveta County",
        "latitude": -3.4,
        "longitude": 37.6833,
        "charge1": "Dealing in meat of wildlife species c/s 98(1) of the WCMA 2013 (Revised 2018)",
        "charge2": "Conveying hunting apparatus into a protected area c/s 102(1)(f) arw Section 102 (1) (h) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "Meat, Manila sack, GPS Coordinates 37M 0409428 UTM 9617353",
        "weight": "3 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "137",
        "dateOfSeizure": "February-2021",
        "nameOfAccused": "Patrick Ngao",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Samburu Trading Centre, Samburu Location in Kinango sub-county of Kwale County",
        "latitude": -3.7,
        "longitude": 39.4833,
        "charge1": "Dealing in bush meat of wildlife species c/s 98(1) of the WCMA 2013 (Misc amendments Act 2018)",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gazelle",
        "exhibit": "Meat",
        "weight": "15 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "138",
        "dateOfSeizure": "January-2021",
        "nameOfAccused": "Juma Chaka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwale County",
        "latitude": -4.174688,
        "longitude": 39.45267,
        "charge1": "Dealing in meat of wildlife species c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "Carcass, 1 torch, 1 panga, 1 knife, sacks",
        "weight": "N/A",
        "judgmentDate": 44420,
        "judgmentOutcome": "Convicted",
        "sentencing": "3 years imprisonment",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2021",
        "nameOfAccused": "Mutua Mbai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwale County",
        "latitude": -4.174688,
        "longitude": 39.45267,
        "charge1": "Dealing in meat of wildlife species c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "Carcass, 1 torch, 1 panga, 1 knife, sacks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "139",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Juma alias Ngao Ndoro",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Samburu in Kinango sub-county within Kwale County",
        "latitude": -3.7,
        "longitude": 39.4833,
        "charge1": "Enganging in meat of wildlife species without permit or other lawful excemption c/s 97 of the WCMA 2013 ( Misc. Amendments act 2018)",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "Meat, Big Sufuria",
        "weight": "4 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "140",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Karisa Chome Chengo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Malomani area in Samburu sub-county within Kwale county",
        "latitude": -3.780688,
        "longitude": 39.275734,
        "charge1": "Being in possession of critically live endangered wildlife species without permit or other lawful exemptions c/s 92(4) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Pangolin",
        "exhibit": "Live pangolin, greenish gunny bag",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Bakari Jawa Mwero",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Malomani area in Samburu sub-county within Kwale county",
        "latitude": -3.780688,
        "longitude": 39.275734,
        "charge1": "Being in possession of critically live endangered wildlife species without permit or other lawful exemptions c/s 92(4) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Pangolin",
        "exhibit": "Live pangolin, greenish gunny bag",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "141",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Nyawa Kaphunza Nyawa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwale County",
        "latitude": -4.174688,
        "longitude": 39.45267,
        "charge1": "Dealing in carcass and meat of wildlife species without permit or other lawful exemption c/s 98(1) arw section 105 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat, motorcycle (registration not displayed)",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "142",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Chengo Kazungu Karisa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mnagoni , Taru area, Samburu sub-county within Kwale county",
        "latitude": -3.7333,
        "longitude": 39.15,
        "charge1": "Dealing in a wildlife of an endangered species without a permit or other lwaful exemption c/c 92 (2) of the WCMA 2013",
        "charge2": "Being in possession of a WT of endangered species c/s 92(4) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "7 pieces of tusks",
        "weight": "18.5 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Kiarie Peter Njoroge",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mnagoni , Taru area, Samburu sub-county within Kwale county",
        "latitude": -3.7333,
        "longitude": 39.15,
        "charge1": "Dealing in a wildlife of an endangered species without a permit or other lwaful exemption c/c 92 (2) of the WCMA 2013",
        "charge2": "Being in possession of a WT of endangered species c/s 92(4) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "7 pieces of tusks",
        "weight": "18.5 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "143",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Joseph Mburu Kamau",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing with meat or carcass of wildlife animal c/s 98(1) of WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippo",
        "exhibit": "Meat",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "144",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Moses Mbugua Mwangi",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in the meat of wildlife species c/s 98(1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo ",
        "exhibit": "Meat, Red TVS motorcycle reg. no. KMFC 928P",
        "weight": "60 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "145",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Daniel Gitu Wanjohi",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Being in possesion of wildlife trophy of endangered species c/s 92 (4) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Turtle ",
        "exhibit": "1/4 litter of Oil",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "146",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Dickson Mureithi",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing with meat of wildife species c/s 98 (1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "55 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Ann Wanjiru",
        "nationality": "N/A",
        "gender": "Female",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing with meat of wildife species c/s 98 (1) of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "55 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "147",
        "dateOfSeizure": "September-2021",
        "nameOfAccused": "Ezekiel Mwangi Wairimu",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy c/s 95(d) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Porcupine",
        "exhibit": "1 head",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "148",
        "dateOfSeizure": "October-2019",
        "nameOfAccused": "Godana Yusuf",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of game meat c/s 98 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Topi",
        "exhibit": "Carcass",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "152",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Humphrey Kokane",
        "nationality": "N/A",
        "gender": "Male",
        "location": "Matomba area Idsowe Sub Location ,Shirikisho Location,Tana Delta",
        "latitude": -2.294794,
        "longitude": 40.123714,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippo",
        "exhibit": "Meat",
        "weight": "50 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2022",
        "nameOfAccused": "Bobison Jaluo",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippo",
        "exhibit": "Meat",
        "weight": "50 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "155",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Lazarus Gonnah Igwo",
        "nationality": "N/A",
        "gender": "Male",
        "location": "Ngao",
        "latitude": -2.409902,
        "longitude": 40.200153,
        "charge1": "Dealing in wildlife meat w/o a permit c/s 98 (1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "Cooked meat, inside a sufuria, Motorcylce reg. no. KMEN 198Z",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Silas Kiwanza Buko",
        "nationality": "N/A",
        "gender": "Male",
        "location": "Ngao",
        "latitude": -2.409902,
        "longitude": 40.200153,
        "charge1": "Dealing in wildlife meat w/o a permit c/s 98 (1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "Cooked meat, inside a sufuria, Motorcylce reg. no. KMEN 198Z",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "156",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Samwel Katana",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife meat w/o a permit c/s 98 (1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "Meat",
        "weight": "52 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "161",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Salim Makorani Ali",
        "nationality": "N/A",
        "gender": "Male",
        "location": "Kajisteni village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "9 carcass",
        "weight": "27 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Dhadho Dhidho Saladha",
        "nationality": "N/A",
        "gender": "Male",
        "location": "Kajisteni village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Dealing in the carcass or meat of wildlife species c/s 98 (1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "9 carcass",
        "weight": "27 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "162",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Alphone Kazungu Kenga",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in carcass or meat of a wildlife species c/s 98(1) WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "72 Carcasses, 1 wild bird, six motorcycles reg. no. KMEB 172B, KMFR 915B, KMFP 871V, KMFQ 878N, KMEK 373V, KMDW 129C, 4 torches, 2 sufurias, 1 panga, 1 slasher, 2 foot pump, 1 catapult, 7 improvised horn",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "168",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Amina Shabani",
        "nationality": "N/A",
        "gender": "Female",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in carcass or meat of wildlife species c/sec 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippo",
        "exhibit": "Meat",
        "weight": "10 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "170",
        "dateOfSeizure": "July-2022",
        "nameOfAccused": "Joyce Sumbuko Habalaiso",
        "nationality": "N/A",
        "gender": "Female",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife meat w/o a permit c/s 98 (1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "13 carcass, Motorcycle reg. no. KMED 294E",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "171",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Swalehe Barisa Hiribae AKA Hiribae Mabuke",
        "nationality": "N/A",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in the carcass of wildlife species 98(1) as read with 105(1) (b) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik,Lesser Kudu",
        "exhibit": "Motocycle reg.KMGB 049W, 2 lesser Kudu carcass",
        "weight": "62.8 kgs Dik Dik Carcass, 2.40 kgs Matumbo,",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "172",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Kenedy Wabwire",
        "nationality": "Ugandan",
        "gender": "Male",
        "location": "Busia Market near Muslim Mosque in Busia Sub-Countyin Busia County",
        "latitude": 0.462453,
        "longitude": 34.107155,
        "charge1": "Being in possession of wildlife trophy c/s 95 WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "3 pieces of Elephant tusks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "173",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Juma Ibrahim",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bulla Baraka area, Madogo Location, Bangale sub-county within Tana River County",
        "latitude": -0.723552,
        "longitude": 39.01673,
        "charge1": "Being in possession of meat of wildlife species c/s 98 (1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Gerenuk",
        "exhibit": "Meat",
        "weight": "4kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "174",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Kelvin Sirma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kapchemutwa Forest in Keiyo North sub-county within Elgeyo Marakwet County",
        "latitude": 0.670275,
        "longitude": 35.507545,
        "charge1": "Cutting and removing forest produce without authority c/s 64(1)(a) and Section 64(2) of the FCMA 2016",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cypress",
        "exhibit": "10 logs",
        "weight": "N/A",
        "judgmentDate": 44630,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Mathew Kipsang",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kapchemutwa Forest in Keiyo North sub-county within Elgeyo Marakwet County",
        "latitude": 0.670275,
        "longitude": 35.507545,
        "charge1": "Cutting and removing forest produce without authority c/s 64(1)(a) and Section 64(2) of the FCMA 2016",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cypress",
        "exhibit": "10 logs",
        "weight": "N/A",
        "judgmentDate": 44630,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "175",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Stephen Wafula",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kaplolo area sub-compartment 7(1) in Keiyo North sub-county within Elgeyo Marakwet County",
        "latitude": 0.742577,
        "longitude": 35.561958,
        "charge1": "Cutting and removing forest produce without authority c/s 64(1)(a) and Section 64(2) of the FCMA 2016",
        "charge2": "Being in possession of logging tools c/s 64(1)(k) arw Sec. 64(2) of the FCMA (No. 34 of 2016)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "10 posts, 3 axes",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2022",
        "nameOfAccused": "Elvis Echami",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kaplolo area sub-compartment 7(1) in Keiyo North sub-county within Elgeyo Marakwet County",
        "latitude": 0.742577,
        "longitude": 35.561958,
        "charge1": "Cutting and removing forest produce without authority c/s 64(1)(a) and Section 64(2) of the FCMA 2016",
        "charge2": "Being in possession of logging tools c/s 64(1)(k) arw Sec. 64(2) of the FCMA (No. 34 of 2016)",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "10 posts, 3 axes",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "176",
        "dateOfSeizure": "November-2022",
        "nameOfAccused": "Benson Gikandi Mathai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gathunga forest,Mt Kenya National Park in Mathira West Sub-County within Nyeri County",
        "latitude": -0.419296,
        "longitude": 36.951701,
        "charge1": "Killing an animal C/sec 67(4) as read with section 67(8) of FCMA 2005",
        "charge2": "Being in possession of a snare for the purpose of capturing an animal c/sec 67(4) as read with section 67(8) of FCMA 2016",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "177",
        "dateOfSeizure": "January-2023",
        "nameOfAccused": "Iphraim Njenga Gatonye",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Hombe Forest of Mathira West Sub County within Nyeri County",
        "latitude": -0.419296,
        "longitude": 36.951701,
        "charge1": "Illegal cutting and removal of Forest Produce C/sec 64(1)(a) and 62(2) as read with section 65(b) of FCMA 2016",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cypress",
        "exhibit": "6 trees",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "178",
        "dateOfSeizure": "July-2021",
        "nameOfAccused": "Benard Ouma Odhiambo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mabera townshipbKuria West Sub County within Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of wildlife trophies of critically endangered species c/sec 92(4) of WCMA 2018",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "6 Tusks",
        "weight": "16.8 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2021",
        "nameOfAccused": "Awuondo Esborn Otieno",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mabera townshipbKuria West Sub County within Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of wildlife trophies of critically endangered species c/sec 92(4) of WCMA 2018",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "6 Tusks",
        "weight": "16.8 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "179",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Kenedy Kidigo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olokirorit area of Kiligoris with Transmara South sub-county of Narok County",
        "latitude": -1.088693,
        "longitude": 35.871492,
        "charge1": "Being in possession of wildlife trophy c/s 95(d) of the WCMA 2013, No. 47 laws of Kenya",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippopotamus",
        "exhibit": "tooth",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "180",
        "dateOfSeizure": "October-2022",
        "nameOfAccused": "Zachary Basweti Ouko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olopikindongoe area of Transmara South within Narok County",
        "latitude": -1.088693,
        "longitude": 35.871492,
        "charge1": "Dealing in wildlife trophy of an endangered species c/s 92(2) arw section 105 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces tusks, Red Boxer motorcycle reg. no. KMDA 995D, black bag",
        "weight": "10.95 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "181",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Jeffa Mwalewa Mwachiti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Chanyiro Village of Mkomba Sub Location",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Dealing in wildlife trophy of an endangered species without permit c/s 92(2) WCMA",
        "charge2": "Being in possession of WT of an endangered species without permit c/s 92(4) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 Elephant tusks",
        "weight": "4.1 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "185",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "Fredrick Lemaron",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mukulenda area of Kuku group ranch conservancy in Loitokitok sub-county within Kajiado",
        "latitude": -2.899099,
        "longitude": 37.750256,
        "charge1": "Dealing in wildlife species meat without permit c/s 98(1) arw sec. 105 of the WCMA No. 47 of 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "Meat, sack. Motorcycles reg. no. KMFC 945D",
        "weight": "100 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2022",
        "nameOfAccused": "John Saitoti Lemtambo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mukulenda area of Kuku group ranch conservancy in Loitokitok sub-county within Kajiado",
        "latitude": -2.899099,
        "longitude": 37.750256,
        "charge1": "Dealing in wildlife species meat without permit c/s 98(1) arw sec. 105 of the WCMA No. 47 of 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "Meat, sack. Motorcycles reg. no. KMFC 945D",
        "weight": "100 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "186",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Mbaluya Ole Kitasho",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Simba Cement in Imbirikani location in Kajiado South Sub-county within Kajiado County",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Dealing in wildlife trophy c/s 84(1) arw sec. 92 and sec. 105 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Tusks",
        "weight": "35.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Frankline Leshan",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Simba Cement in Imbirikani location in Kajiado South Sub-county within Kajiado County",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Dealing in wildlife trophy c/s 84(1) arw sec. 92 and sec. 105 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Tusks",
        "weight": "35.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Uputa Murinke",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Simba Cement in Imbirikani location in Kajiado South Sub-county within Kajiado County",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Dealing in wildlife trophy c/s 84(1) arw sec. 92 and sec. 105 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Tusks",
        "weight": "35.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2022",
        "nameOfAccused": "Richard Leshan",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Simba Cement in Imbirikani location in Kajiado South Sub-county within Kajiado County",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Dealing in wildlife trophy c/s 84(1) arw sec. 92 and sec. 105 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "Tusks",
        "weight": "35.6 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "187",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Kinyili Mwanzue",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwasang'ombe village in Nzaui sub-county within Makueni County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in wildlife trophy c/s 92(2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "1,183 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Titus Munywoki Mwanzue",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwasang'ombe village in Nzaui sub-county within Makueni County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in wildlife trophy c/s 92(2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "1,183 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Francis Zakayo Muema",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwasang'ombe village in Nzaui sub-county within Makueni County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in wildlife trophy c/s 92(2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "1,183 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Denis Mwongela Muthoka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwasang'ombe village in Nzaui sub-county within Makueni County",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Dealing in wildlife trophy c/s 92(2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "1,183 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "188",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Peter Mwania Wambua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwitasiano area in Kibwezi sub-county in Makueni County",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Dealing in the carcass (Meat) of a wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "4 pieces of Meat",
        "weight": "4 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "190",
        "dateOfSeizure": "February-2023",
        "nameOfAccused": "Shadrack Isaya",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "College in within Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of a specified endangered wildlife trophy without permit or other lawful exemption in violation of sec 92(4) of WCMA",
        "charge2": "Dealing in WT of a specified endangered species without permit or other lawful exemption in contravention to sec 92(2) of WCMA 2013",
        "charge3": "Being unlawfully present in Kenya c/s 53(1) (j) as read with section 52(3) (I) of the Immigration Act 2011",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "3 Elephant tusks",
        "weight": "6.45 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2023",
        "nameOfAccused": "Wafula Mulindi",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "College in within Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of a specified endangered wildlife trophy without permit or other lawful exemption in violation of sec 92(4) of WCMA",
        "charge2": "Dealing in WT of a specified endangered species without permit or other lawful exemption in contravention to sec 92(2) of WCMA 2013",
        "charge3": "Being unlawfully present in Kenya c/s 53(1) (j) as read with section 52(3) (I) of the Immigration Act 2011",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 Elephant tusks",
        "weight": "6.45 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2023",
        "nameOfAccused": "Msambi Antony",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "College in within Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of a specified endangered wildlife trophy without permit or other lawful exemption in violation of sec 92(4) of WCMA",
        "charge2": "Dealing in WT of a specified endangered species without permit or other lawful exemption in contravention to sec 92(2) of WCMA 2013",
        "charge3": "Being unlawfully present in Kenya c/s 53(1) (j) as read with section 52(3) (I) of the Immigration Act 2011",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "5 Elephant tusks",
        "weight": "6.45 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "191",
        "dateOfSeizure": "August-2021",
        "nameOfAccused": "Joseph Yonga Owino",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Olasi area Nyatike Sub County Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of a specified endangered wildlife trophy without permit or other lawful exemption in violation of sec 92(4) of WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "Dealing in WT of a specified endangered species without permit or other lawful exemption in contravention to sec 92(2) of WCMA 2013",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "7 Elephant tusks",
        "weight": "43.1 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2021",
        "nameOfAccused": "Kennedy Omollo Odhiambo",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Olasi area Nyatike Sub County Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of a specified endangered wildlife trophy without permit or other lawful exemption in violation of sec 92(4) of WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "Dealing in WT of a specified endangered species without permit or other lawful exemption in contravention to sec 92(2) of WCMA 2013",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "7 Elephant tusks",
        "weight": "43.1 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "192",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Francis Kamau Thiongo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olasi area Nyatike Sub County Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of a specified endangered wildlife trophy without permit or other lawful exemption in violation of sec 92(4) of WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "Dealing in WT of a specified endangered species without permit or other lawful exemption in contravention to sec 92(2) of WCMA 2013",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "1 Elephant tusk , Black bag",
        "weight": "5kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Moses Mbugua gacheru",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olasi area Nyatike Sub County Migori County",
        "latitude": -0.075176,
        "longitude": 34.774507,
        "charge1": "Being in possession of a specified endangered wildlife trophy without permit or other lawful exemption in violation of sec 92(4) of WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "Dealing in WT of a specified endangered species without permit or other lawful exemption in contravention to sec 92(2) of WCMA 2013",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "1 Elephant tusk , Black bag",
        "weight": "5kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "194",
        "dateOfSeizure": "February-2020",
        "nameOfAccused": "Polycarp Gikunda Ikiungu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mukothima Market in Tharaka nithi North sub county within Tharaka nithi County",
        "latitude": 0.01277,
        "longitude": 37.944805,
        "charge1": "Being in possession of a specified endangered wildlife trophy without a permit or other lawful exemption c/sec 92 (2) of the WCMA 2013",
        "charge2": "Dealing in wildlife trophy of a specified endangered species without a permit or other lawful exemption c/sec 92 (2) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces Elephant tusk",
        "weight": "4kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2020",
        "nameOfAccused": "Nicholus KirimiMuriuki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mukothima Market in Tharaka nithi North sub county within Tharaka nithi County",
        "latitude": 0.01277,
        "longitude": 37.944805,
        "charge1": "Being in possession of a specified endangered wildlife trophy without a permit or other lawful exemption c/sec 92 (2) of the WCMA 2013",
        "charge2": "Dealing in wildlife trophy of a specified endangered species without a permit or other lawful exemption c/sec 92 (2) of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces Elephant tusk",
        "weight": "4kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "195",
        "dateOfSeizure": "January-2023",
        "nameOfAccused": "John Mucee Nyagah",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mukothima area in Tharaka nithi North sub county within Tharaka nithi County",
        "latitude": 0.01277,
        "longitude": 37.944805,
        "charge1": "Being in possession of a specified endangered wildlife trophy without a permit or other lawful exemption c/sec 92 (4) as read with 105 of the WCMA 2013",
        "charge2": "Dealing in wildlife trophy of a specified endangered species without a permit or other lawful exemption c/sec 92 (2) as read with 105 of the of the WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "5 pieces Elephant tusk, M/ Cycle KMF 704 Q",
        "weight": "21.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "196",
        "dateOfSeizure": "April-2022",
        "nameOfAccused": "Jamlik Muriuki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kaburia Miitine area Imenti Sub County within Meru County",
        "latitude": 0.049979,
        "longitude": 37.650006,
        "charge1": "Dealing in a wildlife trophy c/sec 95(b) of the WCMA 2013",
        "charge2": "Dealing in meat of a wildlife species c/sec 98(1) of WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "2 bushback horns",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "197",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Jamlick Muthukumi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "KaburiaForest in Imenti South Sub County within Meru County",
        "latitude": 0.049979,
        "longitude": 37.650006,
        "charge1": "Removing forest produce C/sec 64 (1) (a) as read with section 64 (2) of FCMA 2016",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Podo tree",
        "exhibit": "11 beams",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Brian Muthukumi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "KaburiaForest in Imenti South Sub County within Meru County",
        "latitude": 0.049979,
        "longitude": 37.650006,
        "charge1": "Removing forest produce C/sec 64 (1) (a) as read with section 64 (2) of FCMA 2017",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Podo tree",
        "exhibit": "11 beams",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Jamlick Muriuki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "KaburiaForest in Imenti South Sub County within Meru County",
        "latitude": 0.049979,
        "longitude": 37.650006,
        "charge1": "Removing forest produce C/sec 64 (1) (a) as read with section 64 (2) of FCMA 2018",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Podo tree",
        "exhibit": "11 beams",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "George Kamau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "KaburiaForest in Imenti South Sub County within Meru County",
        "latitude": 0.049979,
        "longitude": 37.650006,
        "charge1": "Removing forest produce C/sec 64 (1) (a) as read with section 64 (2) of FCMA 2019",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Podo tree",
        "exhibit": "11 beams",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "198",
        "dateOfSeizure": "October-2022",
        "nameOfAccused": "Ali Ahmed Boya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Butiye in Moyale",
        "latitude": 3.52419,
        "longitude": 39.051268,
        "charge1": "Dealing with carcass of meat of wildlife species c/s 98(1) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "3 skinned Dik Dik",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "199",
        "dateOfSeizure": "November-2022",
        "nameOfAccused": "Loise Karimi",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Gikiero Area within Mbeere South Sub- County in Embu County",
        "latitude": -0.53767,
        "longitude": 37.458395,
        "charge1": "Removing parts of shrubs from provisional forest with intent to export without authority c/s 67(8)(d) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "3 sacks of Sandalwood",
        "weight": "104 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2022",
        "nameOfAccused": "Charles Njiru Nyaga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gikiero Area within Mbeere South Sub- County in Embu County",
        "latitude": -0.53767,
        "longitude": 37.458395,
        "charge1": "Removing parts of shrubs from provisional forest with intent to export without authority c/s 67(8)(d) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "3 sacks of Sandalwood",
        "weight": "104 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "200",
        "dateOfSeizure": "April-2020",
        "nameOfAccused": "Japheth Muteti Mureithi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mbeere",
        "latitude": null,
        "longitude": null,
        "charge1": "Being in possession of wildlife trophy without permit c/sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces Elephant tusks",
        "weight": "21.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2020",
        "nameOfAccused": "Shadrack Mutuku Kayunga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mbeere",
        "latitude": null,
        "longitude": null,
        "charge1": "Being in possession of wildlife trophy without permit c/sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces Elephant tusks",
        "weight": "21.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "201",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "Milton Mureithi Njuki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ishiara market near St Ann Clinic In Mbeere Sub County",
        "latitude": -0.45,
        "longitude": 37.7833,
        "charge1": "Dealing in wildlife trophy of endangered species c/sec 92(2) as read with 105(1) of WCMA",
        "charge2": "Dealing in WT of endangered species c/sec 95(b) of WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Crocodile, Python",
        "exhibit": "1 Crocodile skin , 7 pieces python Skin ,3 Motocycles ; KMON 396V,KMEW 050Y,KMEE 639D",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "Isaak Mugendi Ngondi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ishiara market near St Ann Clinic In Mbeere Sub County",
        "latitude": -0.45,
        "longitude": 37.7833,
        "charge1": "Dealing in wildlife trophy of endangered species c/sec 92(2) as read with 105(1) of WCMA",
        "charge2": "Dealing in WT of endangered species c/sec 95(b) of WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Crocodile, Python",
        "exhibit": "1 Crocodile skin , 7 pieces python Skin ,3 Motocycles ; KMON 396V,KMEW 050Y,KMEE 639D",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "John Nyaga Muturi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ishiara market near St Ann Clinic In Mbeere Sub County",
        "latitude": -0.45,
        "longitude": 37.7833,
        "charge1": "Dealing in wildlife trophy of endangered species c/sec 92(2) as read with 105(1) of WCMA",
        "charge2": "Dealing in WT of endangered species c/sec 95(b) of WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Crocodile, Python",
        "exhibit": "1 Crocodile skin , 7 pieces python Skin ,3 Motocycles ; KMON 396V,KMEW 050Y,KMEE 639D",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "202",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Josphat Mtoi Kuri",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwale Silent Lodge ,Kwale town",
        "latitude": -4.174688,
        "longitude": 39.45267,
        "charge1": "Dealing in wildlife trophy of an endangered species without permit c/s 92(2) WCMA",
        "charge2": "Posession of WT of an endangered species without permit c/s 92(4) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "12 pieces Elephant tusk",
        "weight": "35 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "203",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Jackson Agwata Oruko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Eburu Village within Naivasha Sub-county of Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Hunting for subsistence c/c 97 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "Meat",
        "weight": "15 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "204",
        "dateOfSeizure": "September-2021",
        "nameOfAccused": "Francis Wambiru Kabiru",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kedongo Ranch within Naivasha Sub-county of Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of meat of a wildlife species c/s 95(d) arw section 95 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat, GPD coordinates 37M 0212999 UTM 9911013",
        "weight": "111 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "205",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Benard Wafula",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Centre one-Eburu in Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Dealing in carcass or meat of any wildlife species c/s 98(1) of WCMA 2013 (As ameded in 2019)",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "Meat, 6 snares, 2 pangas, a spear, 2 knives, motorcucle reg. no. KMES 962V, GPS Coordinates 37M 0182880 UTM 99252551",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "James Mwangi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Centre one-Eburu in Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Dealing in carcass or meat of any wildlife species c/s 98(1) of WCMA 2013 (As ameded in 2019)",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "Meat, 6 snares, 2 pangas, a spear, 2 knives, motorcucle reg. no. KMES 962V, GPS Coordinates 37M 0182880 UTM 99252551",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Peter Ndirangu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Centre one-Eburu in Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Dealing in carcass or meat of any wildlife species c/s 98(1) of WCMA 2013 (As ameded in 2019)",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "Meat, 6 snares, 2 pangas, a spear, 2 knives, motorcucle reg. no. KMES 962V, GPS Coordinates 37M 0182880 UTM 99252551",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Samuell Ndun'gu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Centre one-Eburu in Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Dealing in carcass or meat of any wildlife species c/s 98(1) of WCMA 2013 (As ameded in 2019)",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "Meat, 6 snares, 2 pangas, a spear, 2 knives, motorcucle reg. no. KMES 962V, GPS Coordinates 37M 0182880 UTM 99252551",
        "weight": "40 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "206",
        "dateOfSeizure": "September-2021",
        "nameOfAccused": "Aduce Nyang'au Temu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maili Mbili area of Naivasha Sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Being in possession of meat of wildlife species c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "21 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "207",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "Stephen Mwangi Njoroge",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gilgil Sub-county within Nakuru County",
        "latitude": -0.499847,
        "longitude": 36.324398,
        "charge1": "Possession of wildlife trophy c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "60 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "Solomon Kirathe Kinuthia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gilgil Sub-county within Nakuru County",
        "latitude": -0.499847,
        "longitude": 36.324398,
        "charge1": "Possession of wildlife trophy c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "60 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "Moses Ambani Shitati",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Gilgil Sub-county within Nakuru County",
        "latitude": -0.499847,
        "longitude": 36.324398,
        "charge1": "Possession of wildlife trophy c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "60 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "208",
        "dateOfSeizure": "January-2020",
        "nameOfAccused": "David Karanja Mokosia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Oserian Ranch in Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of Government Trophy c/s 95 are section 105 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Ostrich",
        "exhibit": "Egg",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "209",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Alex Kipkemei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Oserian Farm of Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Hunting for bushmeat c/s 97 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "Meat",
        "weight": "25 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Edwin Wanjala",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Oserian Farm of Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Hunting for bushmeat c/s 97 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "Meat",
        "weight": "25 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "210",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "John Songs Njomo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marula Conservancy Naivasha sub-County within Nakuru County",
        "latitude": -0.453034,
        "longitude": 37.044424,
        "charge1": "Hunting for bushmeat c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "Meat, snare",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "211",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Robert Kure",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kedongo Ranch within Naivasha Sub-county of Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of meat of wildlife species c/s 95 (d) of the amended WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat, GPS Coordinates 37M 021020 UTM 9907609",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2021",
        "nameOfAccused": "Musa Ekwam",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kedongo Ranch within Naivasha Sub-county of Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of meat of wildlife species c/s 95 (d) of the amended WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat, GPS Coordinates 37M 021020 UTM 9907609",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "212",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Samson Imboko Isaiah",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marula Conservancy Naivasha sub-County within Nakuru County",
        "latitude": -0.453034,
        "longitude": 37.044424,
        "charge1": "Hunting for Bush-meat c/s 97 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "Meat, GPS Coordinates 37M 0204704 UTM 9933775",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Samuel Walubengo Albert",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marula Conservancy Naivasha sub-County within Nakuru County",
        "latitude": -0.453034,
        "longitude": 37.044424,
        "charge1": "Hunting for Bush-meat c/s 97 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "Meat, GPS Coordinates 37M 0204704 UTM 9933775",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Joseph Eshiman Lokdong'oi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marula Conservancy Naivasha sub-County within Nakuru County",
        "latitude": -0.453034,
        "longitude": 37.044424,
        "charge1": "Hunting for Bush-meat c/s 97 of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "Meat, GPS Coordinates 37M 0204704 UTM 9933775",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "213",
        "dateOfSeizure": "August-2020",
        "nameOfAccused": "Zeddy Macharia Chege",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kargita Estate in Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of meat of wildlife species c/s 95 (d) of the amended WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "15 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "214",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Samuel Kamande Waniaru",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Delamere area Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of meat of a wildlife species c/s 98 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "10 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "215",
        "dateOfSeizure": "December-2020",
        "nameOfAccused": "Torinyo Ole Mokosio",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Suswa Naivasha sub-county within Nakuru County",
        "latitude": -1.080733,
        "longitude": 36.233578,
        "charge1": "Hunting wildlife for bush meat trade c/s 98(1) of the amended WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "Meat, Panga, Hunting dog",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "216",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Simon Lopeyo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kedongo Ranch within Naivasha Sub-county of Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of Meat of a Wildlife species c/s 95(d) of the ammended WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "50 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "James Lowoi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kedongo Ranch within Naivasha Sub-county of Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of Meat of a Wildlife species c/s 95(d) of the ammended WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "Meat",
        "weight": "50 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2020",
        "nameOfAccused": "David Karanja Mokosia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Oserian Ranch in Naivasha sub-county within Nakuru County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Possession of Government Trohy c/s 95 arw section 105 of WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Ostrich",
        "exhibit": "Egg",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "219",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "John Kamuri",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Fly over along Nairobi - Naivasha Highway within Kinangop Sub-county of Nyandarua County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Dealing in wildlife trophy c/s 92 (2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks",
        "weight": "11 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "Stephen Mwangi Mwaniki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Fly over along Nairobi - Naivasha Highway within Kinangop Sub-county of Nyandarua County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Dealing in wildlife trophy c/s 92 (2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks",
        "weight": "11 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2020",
        "nameOfAccused": "Hezekiel Owiye Majengo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Fly over along Nairobi - Naivasha Highway within Kinangop Sub-county of Nyandarua County",
        "latitude": -0.719343,
        "longitude": 36.433064,
        "charge1": "Dealing in wildlife trophy c/s 92 (2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks",
        "weight": "11 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "220",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Muendet Kordoni",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Enkusero area of Kuku group ranch conservancy in Loitokitok",
        "latitude": -2.899099,
        "longitude": 37.750256,
        "charge1": "Dealing in wildlife species carcasses without a permit c/s 98(1) arw section 105 of the WCMA No. 47 of 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "3 carcasses",
        "weight": "45 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "221",
        "dateOfSeizure": "December-2022",
        "nameOfAccused": "Ngusa Kitumu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Elerai area of Kimana Division in Loitokitok sub-county within Kajiado County",
        "latitude": -2.927112,
        "longitude": 37.5095,
        "charge1": "Killing of wildlife species without permit c/s 95(a) arw Sec. 105(1) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "1 Carcass, imrpvised horn, 1 panga, 1 Knife",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "222",
        "dateOfSeizure": "September-2021",
        "nameOfAccused": "Mutua Kiilo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mikululo area, Kiboko location in Makindu within Makueni County",
        "latitude": -2.288375,
        "longitude": 37.8193,
        "charge1": "Being in possession of WT c/s 92(4) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "223",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Domminic Mwinde Makau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tsavo East National Park along Athi River within Kibwezi Sub-county Makueni County",
        "latitude": -1.456962,
        "longitude": 36.974754,
        "charge1": "Being in possession of meat of wildlife species c/s 98(1) of the WCMA 2013",
        "charge2": "Entering in a National Park c/s 102(1) WCMA 2013",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "Meat, 37M 0425592 UTM 9716565",
        "weight": "35 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "224",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Kennedy Kilunda Kioko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nthongoni area within Kibwezi sud-county in Makueni County",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Dealing in wildlife trophy c/s 92(2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "7 pieces",
        "weight": "450 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Erick Musyoka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nthongoni area within Kibwezi sud-county in Makueni County",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Dealing in wildlife trophy c/s 92(2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "7 pieces",
        "weight": "450 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2022",
        "nameOfAccused": "Benard Mutie Nzinga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nthongoni area within Kibwezi sud-county in Makueni County",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Dealing in wildlife trophy c/s 92(2) of the WCMA 2013",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "7 pieces",
        "weight": "450 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "225",
        "dateOfSeizure": "February-2020",
        "nameOfAccused": "Denis Kaindio",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Camel Crossing, Kora National Park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Being in possession of an endangered wildlife trophy w/o permit c/s 92(4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "4 pieces of elephant tusks ",
        "weight": "1.2 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "226",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Daniel Mutai Musonik",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bisanadi National Reserve",
        "latitude": null,
        "longitude": null,
        "charge1": "Stealing by servant c/s 281 of the penal code",
        "charge2": "Stealing by servant c/s 281 of the penal code",
        "charge3": "Neglect of official duties c/s 128 arw 36 of the penal code",
        "charge4": "Neglect of official duties c/s 128 arw 36 of the penal code",
        "charge5": "Neglect of official duties c/s 128 arw 36 of the penal code",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "227",
        "dateOfSeizure": "October-2021",
        "nameOfAccused": "Linus Gikundi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Karampton Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of a specified endangered wildlife trophy w/o a permit c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "0.63 kgs",
        "judgmentDate": 44540,
        "judgmentOutcome": "Convicted ",
        "sentencing": "3m i/d 5 yrs",
        "caseStatus": "Concluded"
    },
    {
        "no": "228",
        "dateOfSeizure": "August-2019",
        "nameOfAccused": "Moses Muthee",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Golo 2 area, Meru National Park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Podo tree",
        "exhibit": "10 poles",
        "weight": "N/A",
        "judgmentDate": 43693,
        "judgmentOutcome": "Withdrawn u/s 35 PC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "229",
        "dateOfSeizure": "August-2019",
        "nameOfAccused": "Zacharia Murimi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tesiwa area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy c/s 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "Snake skin",
        "weight": "N/A",
        "judgmentDate": 44252,
        "judgmentOutcome": "Acquitted u/s 215 CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "230",
        "dateOfSeizure": "July-2019",
        "nameOfAccused": "Regina Kathabi",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Nkinyanga location",
        "latitude": null,
        "longitude": null,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Mukamia Lutea, Kiiri",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 43668,
        "judgmentOutcome": "Convicted ",
        "sentencing": "6 mths CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2019",
        "nameOfAccused": "Lucy Kanini",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Tesiwa area",
        "latitude": null,
        "longitude": null,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Mukamia Lutea, Kiiri",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 43668,
        "judgmentOutcome": "Convicted ",
        "sentencing": "6 mths CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "231",
        "dateOfSeizure": "October-2020",
        "nameOfAccused": "Kobia M'kioomi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kiboko Airstrip",
        "latitude": -1.8,
        "longitude": 37.3833,
        "charge1": "Cutting and removing forest produce c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Muturu",
        "exhibit": "1 piece of indigenous tree",
        "weight": "N/A",
        "judgmentDate": 44168,
        "judgmentOutcome": "Discharged u/s 35 PC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "232",
        "dateOfSeizure": "June-2019",
        "nameOfAccused": "Joseph Musili",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngaya Forest ",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Hunting for the purpose of bush meat trade c/s 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "5 wire snares and 1 carcass of waterbuck",
        "weight": "10 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Withdrawn u/s 87 (a) CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2019",
        "nameOfAccused": "Aminadam Munyoki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Triangle area within Meru National Park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Hunting for the purpose of bush meat trade c/s 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "5 wire snares and 1 carcass of waterbuck",
        "weight": "10 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Withdrawn u/s 87 (a) CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "233",
        "dateOfSeizure": "May-2019",
        "nameOfAccused": "James Muthee",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Offbeat area, Meru National Park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Cutting down trees c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "Possession of logging tools or equipment c/s  c/s 64 (1)(k) FCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Balanites Aegyptica",
        "exhibit": "1 panga, 3 spade, and a fork jembe",
        "weight": "N/A",
        "judgmentDate": 43627,
        "judgmentOutcome": "Withdrawn u/s 87 (a) CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "234",
        "dateOfSeizure": "November-2019",
        "nameOfAccused": "Solomon Kimemia Mwangi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngaya Forest ",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Entering a national park c/s 102(1)(a) WCMA",
        "charge2": "Logging in a national park c/s 102(1)(c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "60 posts of red cider",
        "weight": "60 posts",
        "judgmentDate": 44585,
        "judgmentOutcome": "Withdrawn u/s 87 (a) CPC - Accused absconded",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2019",
        "nameOfAccused": "Francis Kagai Njuguna",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngaya Forest ",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Entering a national park c/s 102(1)(a) WCMA",
        "charge2": "Logging in a national park c/s 102(1)(c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "60 posts of red cider",
        "weight": "60 posts",
        "judgmentDate": 44585,
        "judgmentOutcome": "Withdrawn u/s 87 (a) CPC - Accused absconded",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "235",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "James Marini Muthui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngaya Forest ",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Entering in a national park c/s 102(1)(a) WCMA",
        "charge2": "Logging in a national park c/s 102(1)(c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "28 posts of red cider",
        "weight": "28 posts",
        "judgmentDate": 44712,
        "judgmentOutcome": "Convicted",
        "sentencing": "C1: 50,000 i/d 6 months; CII: 200,000 i/d 2 yrs",
        "caseStatus": "Concluded "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Joseph Mungai Mwaniki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Daya Village ",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Entering in a national park c/s 102(1)(a) WCMA",
        "charge2": "Logging in a national park c/s 102(1)(c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "28 posts of red cider",
        "weight": "28 posts",
        "judgmentDate": 44712,
        "judgmentOutcome": "Convicted",
        "sentencing": "C1: 50,000 i/d 6 months; CII: 200,000 i/d 2 yrs",
        "caseStatus": "Concluded "
    },
    {
        "no": "236",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Linus Gikundi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Aberdare sub-county",
        "latitude": -1.166392,
        "longitude": 36.825279,
        "charge1": "Possession of wildlife trophy c/s 92 (4) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 pieces of elephant tusks",
        "weight": "0.68 kgs",
        "judgmentDate": 44540,
        "judgmentOutcome": "Convicted",
        "sentencing": "3m i/d 5 yrs",
        "caseStatus": "Concluded"
    },
    {
        "no": "237",
        "dateOfSeizure": "August-2021",
        "nameOfAccused": "Geoffrey Kailika",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Suguroi Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "30 posts",
        "weight": "N/A",
        "judgmentDate": 44425,
        "judgmentOutcome": "Convicted",
        "sentencing": "10,000 i/d 4 mths",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2021",
        "nameOfAccused": "David Bundi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Suguroi Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "30 posts",
        "weight": "N/A",
        "judgmentDate": 44425,
        "judgmentOutcome": "Convicted",
        "sentencing": "10,000 i/d 4 mths",
        "caseStatus": "Concluded"
    },
    {
        "no": "238",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Morris Mutea",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Aberdare sub-county",
        "latitude": -1.166392,
        "longitude": 36.825279,
        "charge1": "Cutting and removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "8 pieces of posts",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Convicted",
        "sentencing": "20,000 i/d 4 mths",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Japhet Gituma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Aberdare sub-county",
        "latitude": -1.166392,
        "longitude": 36.825279,
        "charge1": "Cutting and removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "8 pieces of posts",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Convicted",
        "sentencing": "20,000 i/d 4 mths",
        "caseStatus": "Concluded"
    },
    {
        "no": "239",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Patrick Bundi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Aberdare sub-county",
        "latitude": -1.166392,
        "longitude": 36.825279,
        "charge1": "Subsistence hunting c/s 97 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Antelope",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 44349,
        "judgmentOutcome": "Convicted",
        "sentencing": "15,000 i/d 3 mths",
        "caseStatus": "Concluded"
    },
    {
        "no": "240",
        "dateOfSeizure": "February-2022",
        "nameOfAccused": "Daniel Murithi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mucheene Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Muako",
        "exhibit": "7 pieces",
        "weight": "N/A",
        "judgmentDate": 44616,
        "judgmentOutcome": "Convicted",
        "sentencing": "8 mths CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "241",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Joseph Mureithi Rimberia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Uruku Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "7 pieces",
        "weight": "N/A",
        "judgmentDate": 44511,
        "judgmentOutcome": "Convicted",
        "sentencing": "30,000 i/d 10 mths",
        "caseStatus": "Concluded"
    },
    {
        "no": "242",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Julius Muriuki Ndudi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mt. Kenya Forest",
        "latitude": 0.529862,
        "longitude": 37.857882,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "2 posts",
        "weight": "N/A",
        "judgmentDate": 44722,
        "judgmentOutcome": "Convicted",
        "sentencing": "15,000 i/d 5 mths",
        "caseStatus": "Concluded"
    },
    {
        "no": "243",
        "dateOfSeizure": "May-2022",
        "nameOfAccused": "Eric Mwiti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mt. Kenya Forest",
        "latitude": 0.529862,
        "longitude": 37.857882,
        "charge1": "Removing forest produce w/o a permit c/s 64 (1)(a) arw 64 (2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Meru Oak, Cyprus, Frame Timber",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 44706,
        "judgmentOutcome": "Convicted",
        "sentencing": "6 mths CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "244",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Erick Kipkorir Mutai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marimba Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Syzygium Guineense",
        "exhibit": "4 posts ",
        "weight": "4 posts",
        "judgmentDate": 44306,
        "judgmentOutcome": "Convicted",
        "sentencing": "2 years probation",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Charles Kipkoech Rotich",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mucheene Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Syzygium Guineense",
        "exhibit": "4 posts ",
        "weight": "4 posts",
        "judgmentDate": 44306,
        "judgmentOutcome": "Convicted",
        "sentencing": "2 years probation",
        "caseStatus": "Concluded"
    },
    {
        "no": "245",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Hillary Cheruiyot Korir",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marimba area",
        "latitude": -0.860267,
        "longitude": 34.940044,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Syzygium Guineense",
        "exhibit": "10 posts",
        "weight": "10 posts",
        "judgmentDate": 44326,
        "judgmentOutcome": "Convicted",
        "sentencing": "12 months probation & Conselling",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Ezekiel Kipkurui Korir",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kithagacha area",
        "latitude": null,
        "longitude": null,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Syzygium Guineense",
        "exhibit": "10 posts",
        "weight": "10 posts",
        "judgmentDate": 44326,
        "judgmentOutcome": "Convicted",
        "sentencing": "12 months probation & Conselling",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2021",
        "nameOfAccused": "Enock Kiprotich Korir",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mutuaru forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Syzygium Guineense",
        "exhibit": "10 posts",
        "weight": "10 posts",
        "judgmentDate": 44326,
        "judgmentOutcome": "Convicted",
        "sentencing": "12 months probation & Conselling",
        "caseStatus": "Concluded"
    },
    {
        "no": "246",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Julius Kipkoech Bett",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kinge Forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Xymalos Monospora",
        "exhibit": "4 posts ",
        "weight": "4 posts",
        "judgmentDate": 44323,
        "judgmentOutcome": "Convicted",
        "sentencing": "5,000 i/d 1 month",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2021",
        "nameOfAccused": "Geoffery Kipkoech Ngano",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Xymalos Monospora",
        "exhibit": "4 posts ",
        "weight": "4 posts",
        "judgmentDate": 44323,
        "judgmentOutcome": "Convicted",
        "sentencing": "5,000 i/d 1 month",
        "caseStatus": "Concluded"
    },
    {
        "no": "247",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Paul Kurgat",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Being possesion of forest produce w/o permit c/s 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Xymalos Monospora",
        "exhibit": "5 posts",
        "weight": "5 posts",
        "judgmentDate": 44371,
        "judgmentOutcome": "Convicted",
        "sentencing": "6 months CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "248",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "David Kibet Tonui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Being possesion of forest produce w/o permit c/s 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Olea European Species",
        "exhibit": "30 posts",
        "weight": "30 posts",
        "judgmentDate": 44378,
        "judgmentOutcome": "Convicted",
        "sentencing": "6 months CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "Peter Kipyegon Cheborgei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Being possesion of forest produce w/o permit c/s 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Olea European Species",
        "exhibit": "30 posts",
        "weight": "30 posts",
        "judgmentDate": 44378,
        "judgmentOutcome": "Convicted",
        "sentencing": "6 months CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2021",
        "nameOfAccused": "William Kipkemoi Tonui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Being possesion of forest produce w/o permit c/s 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Olea European Species",
        "exhibit": "30 posts",
        "weight": "30 posts",
        "judgmentDate": 44378,
        "judgmentOutcome": "Convicted",
        "sentencing": "6 months CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "249",
        "dateOfSeizure": "July-2021",
        "nameOfAccused": "Daniel Langat",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Being in possession of forest produce c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Xymalos Monospora",
        "exhibit": "5 posts",
        "weight": "5 posts",
        "judgmentDate": 44406,
        "judgmentOutcome": "Convicted",
        "sentencing": "3 years probation",
        "caseStatus": "Concluded"
    },
    {
        "no": "250",
        "dateOfSeizure": "July-2021",
        "nameOfAccused": "David Mutai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Transporting forest produce w/o a valid licence c/s Reg 11(1)(a) arw Reg 27 Forest Harvesting Rules 2009",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 44405,
        "judgmentOutcome": "Convicted",
        "sentencing": "fine 5,000 i/d 1 month imprisonment",
        "caseStatus": "Concluded"
    },
    {
        "no": "251",
        "dateOfSeizure": "November-2021",
        "nameOfAccused": "Richard Tonui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Cutting and removing forest produce c/s 64(1)(a) arw 64(2) & 68(1) FCMA",
        "charge2": "Being in possession of logging equipment in a public forest c/s 64(1)(k) arw 64(2) FCMA",
        "charge3": "Being present in a public forest between 7pm & 6am c/s 64(1)(b) arw 64(2) FCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cypress",
        "exhibit": "15 posts of cypress, axe, panga, 2 ropes",
        "weight": "N/A",
        "judgmentDate": 44530,
        "judgmentOutcome": "Withdrawn",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "252",
        "dateOfSeizure": "January-2021",
        "nameOfAccused": "Geoffrey Rigen",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Removing forest produce from a public forest c/s 64(1)(a) arw 64(2) FCMA",
        "charge2": "Possession of logging tool c/s 64(1)(k) arw 64(2) FCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Xymalos Monospora",
        "exhibit": "10 posts, panga, axe",
        "weight": "N/A",
        "judgmentDate": 44210,
        "judgmentOutcome": "Convicted",
        "sentencing": "5 months CSO",
        "caseStatus": "Concluded"
    },
    {
        "no": "253",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Joshua Mwengea Mwanzia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibwezi",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Mashuba Ivuti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibwezi",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Tito Munguti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibwezi",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Muema Kamuti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibwezi",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "2 tusks",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "254",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Musyoki Nzioka Mutia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Triangle area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge3": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "255",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Peter Mutee Mutua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kerokenyi",
        "latitude": null,
        "longitude": null,
        "charge1": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge2": "Harvesting sandalwood Sec 53 (1) FA 2005",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "256",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Joseph Mutie Mwania",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mangelete",
        "latitude": -2.7,
        "longitude": 38.1333,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "71 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Stephen Ndambuki Mutwiwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mangelete",
        "latitude": -2.7,
        "longitude": 38.1333,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "71 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Joseph Mutiso Daviv Alias Joshua Kyalo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mangelete",
        "latitude": -2.7,
        "longitude": 38.1333,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "71 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "257",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "James Mutunga ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mbui - Nzau area",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Rael Nduku Kiatine",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mbui - Nzau area",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "258",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "James Mwania Mutandi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mtito Andei township",
        "latitude": -2.692401,
        "longitude": 38.165405,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "259",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Muinde Muya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Chyullu National park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge3": "Conveying snares Sec 102 (1) (f) WCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "260",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Cleophas Maithya Kimuyu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Emali",
        "latitude": -2.081448,
        "longitude": 37.47699,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "10 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "261",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Daniel Mutuku Kinyanjui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Emali",
        "latitude": -2.081448,
        "longitude": 37.47699,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard",
        "exhibit": "N/A",
        "weight": "Skin",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "262",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Omar Mohammed",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Athi - salam village",
        "latitude": -1.913858,
        "longitude": 34.096466,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "N/A",
        "weight": "22 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "263",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "David Mutua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Makindu town",
        "latitude": -2.288375,
        "longitude": 37.8193,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "264",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Patrick Mutuku Ngumbi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Triangle area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "120 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "265",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Moses Yohana",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngazi",
        "latitude": -4.584512,
        "longitude": 38.339026,
        "charge1": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "2 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "266",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Danson Nzuki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kambu market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Crocodile",
        "exhibit": "N/A",
        "weight": "skin",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "267",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "John Chungwe Waityhaka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ikayo area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "1 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "268",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Joseph Mutuku Muteti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Triangle area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "2 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "269",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Patricia Mwongeri Mbithi",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Manyoya",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "31 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Dominic Makai Kimeu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Manyoya",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "31 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "270",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "David Mutua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Makindu township",
        "latitude": -2.288375,
        "longitude": 37.8193,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "N/A",
        "weight": "1 skin",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "271",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Patrick Kamanthe Muutu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Muuri vilage",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "3 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Mumo Nthumbi Mwaniki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Muuri vilage",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "3 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "272",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "John Mutuku Wambua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Emali",
        "latitude": -2.081448,
        "longitude": 37.47699,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "11 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Emmanuel Ngwili Mbinyo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Emali",
        "latitude": -2.081448,
        "longitude": 37.47699,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "11 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "273",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Bondo Nziuki Lossi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kaunguni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "James Mutua Kiluti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kaunguni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "274",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Mwakera Mukala",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kishushe",
        "latitude": -3.282402,
        "longitude": 38.300674,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Pangolin",
        "exhibit": "N/A",
        "weight": "live",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Edwin Mwakera",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kishushe",
        "latitude": -3.282402,
        "longitude": 38.300674,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Pangolin",
        "exhibit": "N/A",
        "weight": "live",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "275",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "David Kalume Chengo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngiluni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying snares Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "24 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Hamisi Kalama Masha",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngiluni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying snares Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "24 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Samuel Chilumo Chivatsi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngiluni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying snares Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "24 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Dennis Gicheru Karanja",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngiluni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying snares Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "24 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Moses Deche Chuma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngiluni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying snares Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "24 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "James Mutungi Koome",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngiluni",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying snares Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "24 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "276",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Kingoo Mathi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Metava Village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant, Lesser Kudu",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "277",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Dominic Muia James",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kililanda Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "Resisting Arrest Sec 103 (a) National Police Service Act 2011",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "278",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Charles Muli Mutisya",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Athi -Kiaoni Village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard,  Python ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Pius Makusya Mbithi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Athi -Kiaoni Village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard,  Python ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "279",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Bryian Mumo Maundu ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Triangle Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge2": "Logging in a National Park Sec 102 (1) (c) WCMA ",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Acacia Tree",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "280",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Koilokon Moisasi",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Emali-Loitoktok road ",
        "latitude": -2.081448,
        "longitude": 37.47699,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA ",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "4.1 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Musyoki Ngui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Emali-Loitoktok road ",
        "latitude": -2.081448,
        "longitude": 37.47699,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA ",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "4.1 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "281",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Muterian Ndukusoi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Chyulu National Park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge2": "Hunting for bush meat trade Sec 98 arw sec 105 WCMA ",
        "charge3": "Possession of meat of wildlife species Sec 98 arw sec 105 WCMA ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "80kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "282",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Wycliffe Mwamboko Mwadime",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kasarani area",
        "latitude": -1.218759,
        "longitude": 36.902604,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "4.5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "283",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Elias Kithire Amos",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maungu area",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Loice Mwalemba Mwakina",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maungu area",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Catherine Auma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maungu area",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "284",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Micheal Mangai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kulalu area",
        "latitude": 1.269876,
        "longitude": 34.759135,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "12.4. kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Munyoki Nzau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kulalu area",
        "latitude": 1.269876,
        "longitude": 34.759135,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "Entry into National Park Sec 102 (1) (a) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "12.4. kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "285",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Samuel Mwangi Mongo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwatate",
        "latitude": -3.50344,
        "longitude": 38.377415,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "8 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "286",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Joseph Malwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maungu",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "45kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Silu Msau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maungu",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "45kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Omar Kauli",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maungu",
        "latitude": -0.984798,
        "longitude": 36.96524,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "45kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "287",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Joseph mwachia Kiroio",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ndii area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "14 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Laban Mbololo Mwaghagha",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ndii area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "14 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "288",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Justine ngewe Rumba",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilibasi",
        "latitude": -3.9666,
        "longitude": 38.95,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "32 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Hassan Alli Mangale",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilibasi",
        "latitude": -3.9666,
        "longitude": 38.95,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "32 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Ndaro Kazungu Changawa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilibasi",
        "latitude": -3.9666,
        "longitude": 38.95,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "32 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "289",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Dismus Mwachori Mwaginda",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kivumbi",
        "latitude": -3.75,
        "longitude": 39.4666,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Duiker",
        "exhibit": "N/A",
        "weight": "3Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "290",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Pascal Mwamburu Mshambala",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sagala Area",
        "latitude": -3.489367,
        "longitude": 38.592003,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rock Hyrax",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "291",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Johnson Mwambari",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Voi town",
        "latitude": -3.397684,
        "longitude": 38.584327,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "8 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Joseph Mwaluma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Voi town",
        "latitude": -3.397684,
        "longitude": 38.584327,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "8 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "292",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Granton Liverson Nyambu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ndara",
        "latitude": -0.058575,
        "longitude": 36.530746,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "12 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Mwanaidi Chiku Mzee",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ndara",
        "latitude": -0.058575,
        "longitude": 36.530746,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "12 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Nashon Njeghe Mterengo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ndara",
        "latitude": -0.058575,
        "longitude": 36.530746,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "12 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "293",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Hussein Mohamed Shongolo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bachuma",
        "latitude": 1.3833,
        "longitude": 38.2166,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "Assault Sec 103 (a) PC",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "6 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Mohamed Wario Bikole",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bachuma",
        "latitude": 1.3833,
        "longitude": 38.2166,
        "charge1": "Possession of Wildlife Trophy Sec 95 WCMA",
        "charge2": "Assault Sec 103 (a) PC",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "6 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "294",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Jonathan Ndunda Wambua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kasighau",
        "latitude": -3.686059,
        "longitude": 38.66954,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying hunting apparatus Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": "6 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "295",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "James Lenjo Mwakilengwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwachuma",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Buffalo",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "296",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Dismus Mwachori Mwaginda",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kivumbi",
        "latitude": -3.75,
        "longitude": 39.4666,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Duiker ",
        "exhibit": "N/A",
        "weight": "3Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "297",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Oscar Mwambui Mlacha",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mgeno ranch",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Impala",
        "exhibit": "N/A",
        "weight": "12 carcass",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "298",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Bakarii Mohamed Farah",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mkuki area",
        "latitude": -0.4666,
        "longitude": 35.6833,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "48 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "299",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Saidi Boniface",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tsavo West NP",
        "latitude": -3.020187,
        "longitude": 33.910819,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Impala, Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "300",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "John Mcharo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tsavo West NP",
        "latitude": -3.020187,
        "longitude": 33.910819,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "5 pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Julius Teka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tsavo West NP",
        "latitude": -3.020187,
        "longitude": 33.910819,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "5 pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "301",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Felix Endesi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rumbo area",
        "latitude": -3.047226,
        "longitude": 37.694775,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "302",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Samwel Laiza",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Patimalo area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 arw sec 105 WMCA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "100 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "303",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Kelvin Ojiambo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bissil Centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 92 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "23 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Geoffrey Wandera Auma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bissil Centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 92 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "23 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Abdikadir Ibrahim",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bissil Centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 92 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "23 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Lemasimo Kuyaa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bissil Centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 92 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "23 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Abdi Hassan Abdi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bissil Centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 92 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "23 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "304",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Dennis Musyoka Kiswii",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Oloitokitok area",
        "latitude": -2.927112,
        "longitude": 37.5095,
        "charge1": "Possession of meat of wildlife species Sec 92 arw sec 105 WCMA",
        "charge2": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "305",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Jackson Mutuku Maweu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Customs area Namanga",
        "latitude": -2.552906,
        "longitude": 36.784859,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra, Giraffe",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "306",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Anthony Mwange",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Loitokitik",
        "latitude": -2.927112,
        "longitude": 37.5095,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant, Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Daniel Muteti",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Loitokitik",
        "latitude": -2.927112,
        "longitude": 37.5095,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant, Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Hadija Seiza Abdi",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Loitokitik",
        "latitude": -2.927112,
        "longitude": 37.5095,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant, Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "307",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Albunus Mbika",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Marurani",
        "latitude": -3.495066,
        "longitude": 36.828058,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Reed buck",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "308",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "John Munkasia Sankori",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimana town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Emmanuel Ketuke Mongo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimana town",
        "latitude": 1.295991,
        "longitude": 34.753278,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "309",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Mwalimu Pola Kitsao",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Giriama Ranch",
        "latitude": -3.8,
        "longitude": 39.5833,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "310",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Karisa Lewa Kutengeneza",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Chakama Range",
        "latitude": -3.18976,
        "longitude": 35.279178,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "1.525 kgs",
        "judgmentDate": 43019,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "311",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Morris Mdimu Matati",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "45 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "312",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "James Juma Walutu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "30 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "313",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "James Kinyua Njagi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa port",
        "latitude": -4.024901,
        "longitude": 39.612036,
        "charge1": "Exporting restricted goods Sec 200 (c) (ii) EACC Act",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "106  pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Falah Manzu Yusuf alias Mohammed Yaki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa port",
        "latitude": -4.024901,
        "longitude": 39.612036,
        "charge1": "Exporting restricted goods Sec 200 (c) (ii) EACC Act",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "106  pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "James Oriechi Omondi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa port",
        "latitude": -4.024901,
        "longitude": 39.612036,
        "charge1": "Exporting restricted goods Sec 200 (c) (ii) EACC Act",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "106  pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Cyrus Ndolo Kimeu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa port",
        "latitude": -4.024901,
        "longitude": 39.612036,
        "charge1": "Exporting restricted goods Sec 200 (c) (ii) EACC Act",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "106  pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Jumbo Gumba Amaheno",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa port",
        "latitude": -4.024901,
        "longitude": 39.612036,
        "charge1": "Exporting restricted goods Sec 200 (c) (ii) EACC Act",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "106  pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Guylord Amaheno Jumba",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa port",
        "latitude": -4.024901,
        "longitude": 39.612036,
        "charge1": "Exporting restricted goods Sec 200 (c) (ii) EACC Act",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "106  pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Justus Wesonga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa port",
        "latitude": -4.024901,
        "longitude": 39.612036,
        "charge1": "Exporting restricted goods Sec 200 (c) (ii) EACC Act",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "106  pieces",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "314",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Yassin Lokorobe",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bamburi",
        "latitude": -3.990488,
        "longitude": 39.70233,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cobra",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Ronald Nganga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Bamburi",
        "latitude": -3.990488,
        "longitude": 39.70233,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cobra",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "315",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Ali mbandi chaka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwale township",
        "latitude": -4.174688,
        "longitude": 39.45267,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Impala",
        "exhibit": "N/A",
        "weight": "4.5 kgs; 30 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "316",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Joto chaka chibunda",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kwale township",
        "latitude": -4.174688,
        "longitude": 39.45267,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": "8 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "317",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Silalei Kusuma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "45 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "318",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Peter Njoroge",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bushbuck",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "319",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Fatuma Omar Nungu",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Nganja",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "41 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "320",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Athman Kombo Ndengu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimarini",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wild pig",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Mohamed Mwagage",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimarini",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wild pig",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "321",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Juma Ali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimarini",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wild pig",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Ngala Mugoma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimarini",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Wild pig",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "322",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Hassan Nyawa Nyale",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilisa",
        "latitude": -3.39128,
        "longitude": 35.763909,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "11 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "323",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Justus Safari Chengo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kazamoyo",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "45 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "324",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Hassan Mwambegu Kanyimbo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mariakani",
        "latitude": -3.863457,
        "longitude": 39.47376,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Kazungu Karisa Charo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mariakani",
        "latitude": -3.863457,
        "longitude": 39.47376,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "325",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Changawa Katana Kiboni",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mariakani",
        "latitude": -3.863457,
        "longitude": 39.47376,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "66 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "326",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Kenga Kisao Charo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Silaloni",
        "latitude": -3.618783,
        "longitude": 39.283331,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "44 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Kathengi Kaigu Kiboni",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Silaloni",
        "latitude": -3.618783,
        "longitude": 39.283331,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "44 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "327",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Wilson Tsuma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Dabaso area",
        "latitude": -3.302213,
        "longitude": 40.011276,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik,  Guinea fowl",
        "exhibit": "N/A",
        "weight": "10 & 1 kgs respectively",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "328",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "John Peter Ngowa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngongoni area",
        "latitude": -3.034077,
        "longitude": 40.137608,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Dealing in meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": "55 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "329",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Ismael guyole ware",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Magharini",
        "latitude": -3.14111,
        "longitude": 40.123325,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "55 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Suleiman galole gobu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Magharini",
        "latitude": -3.14111,
        "longitude": 40.123325,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "55 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "330",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Abdi Issack Ibrahim",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Dadaab",
        "latitude": 0.053303,
        "longitude": 40.30848,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Ibrahim Bare Mohamed",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Dadaab",
        "latitude": 0.053303,
        "longitude": 40.30848,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "331",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Kipsop Timothy Kimutai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nakuru County Post Office",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cape Eagle - Owl",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Paul Chebii Keibo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nakuru County Post Office",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cape Eagle - Owl",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Peter Sang",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nakuru County Post Office",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cape Eagle - Owl",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Philip Cheruiyot Chebonei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nakuru County Post Office",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cape Eagle - Owl",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Robert Kipkosgei Yego",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nakuru County Post Office",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cape Eagle - Owl",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "332",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Charles Musembi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kapiti plains ranch",
        "latitude": -0.60604,
        "longitude": 37.188324,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": 15,
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "333",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Stephen Wambua Ndoto",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kavomboni-Lukenya area",
        "latitude": -1.955763,
        "longitude": 35.511667,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying uninspected meat Regulation 8 (7) arw reg. 16 (2) of the Meat Control Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": 600,
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Titus Mwinde ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kavomboni-Lukenya area",
        "latitude": -1.955763,
        "longitude": 35.511667,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Conveying uninspected meat Regulation 8 (7) arw reg. 16 (2) of the Meat Control Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": 600,
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "334",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Mathew Kilonzo Nziyembi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ilimamen area ",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe",
        "exhibit": "N/A",
        "weight": 250,
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "335",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Bonface Musyoka Wambua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kasikeni market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "336",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Morepet Reson",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Loita center",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "32 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "337",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Joseph Kamau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Oloontoto",
        "latitude": null,
        "longitude": null,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "11 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "338",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Kasingwa Ole dokony",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Loita forest",
        "latitude": 2.618149,
        "longitude": 34.822876,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "elephant",
        "exhibit": "N/A",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "339",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Wilson kamau ngige",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ewaso ngiro",
        "latitude": 0.640608,
        "longitude": 37.661,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "elephant",
        "exhibit": "N/A",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "340",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Sidian Karenka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42878,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "341",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "Wilson kamau ngige",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ewaso ngiro",
        "latitude": 0.640608,
        "longitude": 37.661,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "elephant",
        "exhibit": "N/A",
        "weight": "4 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "342",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Paul Kipyegon Kirui",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Chepseos center",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "343",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Gilbert Cheruiyot Langat",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Chepseos center",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "5 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "344",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "James Ngugi",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Eldoret-Nakuru road ",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "David Kimani",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Eldoret-Nakuru road ",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Beatrice Ngonyo",
        "nationality": "Kenyan ",
        "gender": "Female",
        "location": "Eldoret-Nakuru road ",
        "latitude": -0.283307,
        "longitude": 36.0713,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "345",
        "dateOfSeizure": "December-2017",
        "nameOfAccused": "Raphael Abichi Amolo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ongayo village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Duiker",
        "exhibit": "N/A",
        "weight": "3 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "346",
        "dateOfSeizure": "December-2017",
        "nameOfAccused": "Pamela Akinyi Obora",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Ongayo village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hare",
        "exhibit": "N/A",
        "weight": "1.50kilos",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "347",
        "dateOfSeizure": "December-2017",
        "nameOfAccused": "Marino Demo Otieno",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kitiro village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Rhino",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "348",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Patrick Mbaabu M'Kaiberia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Makutano Junction",
        "latitude": 1.256335,
        "longitude": 35.091267,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge2": "Possession of wildlife trophy Sec 95 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "349",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Irene Karamana Nyaga ",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Murinya area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge2": "Possession of wildlife trophy Sec 95 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "9 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Joseph Kailikia Murithi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Murinya area",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge2": "Possession of wildlife trophy Sec 95 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "9 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "350",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Lawrence Mugambi Riungu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibumbu area",
        "latitude": -1.5166,
        "longitude": 37.4333,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge2": "Possession of wildlife trophy Sec 95 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Erastus Mugendi Salesio",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibumbu area",
        "latitude": -1.5166,
        "longitude": 37.4333,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge2": "Possession of wildlife trophy Sec 95 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "351",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Joseph Ambao",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Meru national park ",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Possession of meat of wildlife species Sec 98 arw sec 105 WMCA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "6 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "352",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Julius Koir Kimutai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Moyian village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippopotamus",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Richard Kiplagat Roho",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Moyian village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Hippopotamus",
        "exhibit": "N/A",
        "weight": "15 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "353",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "David Loolarini ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olaioi area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Emmanuel Kipio Sindo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olaioi area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "50 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "354",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Lemugu Loongonyo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mugie Ranch ",
        "latitude": -0.335528,
        "longitude": 37.645866,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Trespass upon private land Sec 3 (1) arw sec 11 Trespass Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "355",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Simon Wanderi Mwathi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Aberdares NP",
        "latitude": null,
        "longitude": null,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Subsistence hunting Sec 97 WCMA ",
        "charge3": "Possession of meat of wildlife species Sec 95 arw sec 98 WCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Offales ",
        "exhibit": "N/A",
        "weight": "3kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "356",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Gerald Ndiritu ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mutara Area",
        "latitude": 0.214144,
        "longitude": 37.791283,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Possession of firearm  Sec 4 (1) arw sec 4 (3) Firearms Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "7.5 kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Gicobi Mwai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mutara Area",
        "latitude": 0.214144,
        "longitude": 37.791283,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Possession of firearm Sec 4 (1) arw sec 4 (3) Firearms Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "7.5kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "357",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Sammy Magana Ngatia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Aberdares NP ",
        "latitude": null,
        "longitude": null,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Removing forest produce  Sec 64 (1) (a) arw sec 64 (2) FA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "358",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Jackson Mbugua Murugu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ol Mptonyi area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "7 tonnes ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Anthony Maina Wahinya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ol Mptonyi area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "7 tonnes ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "359",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Anthony Maina Ngunjiri",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Survey area ",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "20kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Geoffrey Kiori Odogo  ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Survey area ",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "20kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "260",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Julius Kigundo ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sosian Ranch/Aiyam",
        "latitude": 0.433315,
        "longitude": 36.679646,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "James Kimanje",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sosian Ranch/Aiyam",
        "latitude": 0.433315,
        "longitude": 36.679646,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Julius Nyerere",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sosian Ranch/Aiyam",
        "latitude": 0.433315,
        "longitude": 36.679646,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "John Arusei ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sosian Ranch/Aiyam",
        "latitude": 0.433315,
        "longitude": 36.679646,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Leonard Kipchumba",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sosian Ranch/Aiyam",
        "latitude": 0.433315,
        "longitude": 36.679646,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Robert Kanyi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sosian Ranch/Aiyam",
        "latitude": 0.433315,
        "longitude": 36.679646,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Panga Morianya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sosian Ranch/Aiyam",
        "latitude": 0.433315,
        "longitude": 36.679646,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Illegal transportation of wildlife trophy Sec 99 (2) (d) arw sec 99 (3) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "361",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Benson Kigen Koech",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "1Kg",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "362",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Seliwa Lodepenyo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing with endangered species Sec 92 WCMA",
        "charge2": "Trespass upon private land Sec 3 (1) arw sec 11 Trespass Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Maria Longoweyi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing with endangered species Sec 92 WCMA",
        "charge2": "Trespass upon private land Sec 3 (1) arw sec 11 Trespass Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Lelemewa Teriwa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "Dealing with endangered species Sec 92 WCMA",
        "charge2": "Trespass upon private land Sec 3 (1) arw sec 11 Trespass Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "363",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "David Mbugwa",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Lodokejek area",
        "latitude": 0.854765,
        "longitude": 36.85841,
        "charge1": "Possession of threatened and endagered species  Sec 92 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "Two and a quarter sacks",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "364",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Peter Esakwan",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Soi area",
        "latitude": 0.770897,
        "longitude": 35.820103,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "22 kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Elizabeth Abenyo",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Soi area",
        "latitude": 0.770897,
        "longitude": 35.820103,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "22 kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing "
    },
    {
        "no": "365",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Gilbert Muthomi Majira",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Central Park Ground Area",
        "latitude": 1.071222,
        "longitude": 34.176776,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Baboon",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "366",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Patrick Mutwiri Nkoroi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kanyoni-Nanyuki Road",
        "latitude": 0.013882,
        "longitude": 37.077824,
        "charge1": "Logging in a National Reserve Sec 102 (1) (c) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Lawrence Thinwa Wambere",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kanyoni-Nanyuki Road",
        "latitude": 0.013882,
        "longitude": 37.077824,
        "charge1": "Logging in a National Reserve Sec 102 (1) (c) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "367",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Lokale Lemiliko",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimanjo Area",
        "latitude": -0.393541,
        "longitude": 37.001526,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 & 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "14 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Mayunga Lengolei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kimanjo Area",
        "latitude": -0.393541,
        "longitude": 37.001526,
        "charge1": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 & 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "14 Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "368",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Paul Karanja Murage",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kanyoni-Nanyuki Road",
        "latitude": 0.013882,
        "longitude": 37.077824,
        "charge1": "Logging in a National Reserve Sec 102 (1) (c) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "369",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Cao Juana",
        "nationality": "Chinese",
        "gender": "Female",
        "location": "JKIA",
        "latitude": -1.765854,
        "longitude": 37.500305,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "120.9kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "370",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "James Chao",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nairobi area",
        "latitude": -1.283253,
        "longitude": 36.817245,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Teresa Wangui Wachira",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Nairobi area",
        "latitude": -1.283253,
        "longitude": 36.817245,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Ann Muthoni charles",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Nairobi area",
        "latitude": -1.283253,
        "longitude": 36.817245,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 105 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "371",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Julius Abluu Adika",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Utawala",
        "latitude": -1.291947,
        "longitude": 36.905131,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "216.76 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Abdinur Ibrahim Ali",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Utawala",
        "latitude": -1.291947,
        "longitude": 36.905131,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "216.76 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Wesley Adwenya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Utawala",
        "latitude": -1.291947,
        "longitude": 36.905131,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "216.76 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Hillary karani",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Utawala",
        "latitude": -1.291947,
        "longitude": 36.905131,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "216.76 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Rawling innocent Ogondi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Utawala",
        "latitude": -1.291947,
        "longitude": 36.905131,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "216.76 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Ronson Njue",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Utawala",
        "latitude": -1.291947,
        "longitude": 36.905131,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "216.76 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Ahmed Mahabub Gendi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Utawala",
        "latitude": -1.291947,
        "longitude": 36.905131,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "216.76 kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "372",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Nashon Maati Mochere",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nairobi West Shopping Centre within Nairobi County",
        "latitude": -1.308744,
        "longitude": 36.824045,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "25kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Charles Wambua Mwema",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nairobi West Shopping Centre within Nairobi County",
        "latitude": -1.308744,
        "longitude": 36.824045,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "25kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Evans Moseti Mochere",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Nairobi West Shopping Centre within Nairobi County",
        "latitude": -1.308744,
        "longitude": 36.824045,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "25kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "373",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Collins Omondi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Transami Bus Stage, Imara Daima within Nairobi County",
        "latitude": -1.328462,
        "longitude": 36.88055,
        "charge1": "Attempted Murder Sec 220 Penal Code",
        "charge2": "Possession of wildlife trophy Sec 95 WCMA",
        "charge3": "Obstructing persons in the execution of their powers Sec 101 (b) WCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "13Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "374",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Geoffrey Muindi Kita",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Thika Road",
        "latitude": -1.035356,
        "longitude": 37.0746,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Pius Mwiti Kaburu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Thika Road",
        "latitude": -1.035356,
        "longitude": 37.0746,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Gilbert Kinyua Mugambi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Thika Road",
        "latitude": -1.035356,
        "longitude": 37.0746,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "375",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "Francis Tembula Mbetu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Juja Road",
        "latitude": -1.100903,
        "longitude": 37.012127,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "James Omollo Awete Miguna",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Juja Road",
        "latitude": -1.100903,
        "longitude": 37.012127,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "376",
        "dateOfSeizure": "December-2017",
        "nameOfAccused": "Thomas Simiyu Lukorito",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "City Mortury",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "377",
        "dateOfSeizure": "December-2017",
        "nameOfAccused": "Paul Muteleu Kipinkane",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Eastleign Shopping Centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "December-2017",
        "nameOfAccused": "Daniel Orimoi Saitabau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Eastleign Shopping Centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "378",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "Samuel Moses Mburu Gitau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa Road",
        "latitude": -4.05052,
        "longitude": 39.667169,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "Dancan Ooko Ngiela",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa Road",
        "latitude": -4.05052,
        "longitude": 39.667169,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "Samuel Omondi Kut",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mombasa Road",
        "latitude": -4.05052,
        "longitude": 39.667169,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Leopard ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "379",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Victor Mwikya Mulavi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Makadara Area",
        "latitude": -4.051634,
        "longitude": 39.674048,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "3.5Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Ongoing"
    },
    {
        "no": "380",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Erastus Mtoto",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kibwezi",
        "latitude": -2.41375,
        "longitude": 37.966335,
        "charge1": "Hunting for bush meat trade Sec 98 arw sec 105 WMCA",
        "charge2": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "15 carcases",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Conviction",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "381",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Stephen Katumo Mutua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Lengolong Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Hunting for bush meat trade Sec 98 arw sec 105 WCMA",
        "charge3": "Possession of meat of wildlife species C/S Sec 98 arw sec 105 WCMA",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "40kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Conviction",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "382",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Charles Gachamba Chege",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kamutonga-Mwatate Road",
        "latitude": -3.50344,
        "longitude": 38.377415,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "10 Kgs",
        "judgmentDate": 43025,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "383",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Emmanuel Musyi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mwatate",
        "latitude": -3.50344,
        "longitude": 38.377415,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "3 Dik-dik carcases",
        "judgmentDate": "N/A",
        "judgmentOutcome": "convicted in count 1 and count 2 withdrawn",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "384",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Francis izaka Msafari",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kajire",
        "latitude": -3.517552,
        "longitude": 38.612149,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42922,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "385",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Hamisi Mwembe",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rukinga ranch",
        "latitude": -3.812629,
        "longitude": 38.638073,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "4 Dik-dik",
        "judgmentDate": 42849,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Mnazi Nyai",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rukinga ranch",
        "latitude": -3.812629,
        "longitude": 38.638073,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "5 Dik-dik",
        "judgmentDate": 42849,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "386",
        "dateOfSeizure": "August-2018",
        "nameOfAccused": "Joseph Nzau",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Galana-Kulale",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "60 kgs",
        "judgmentDate": 42961,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "387",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Mulatya Mungao",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Sisal ",
        "latitude": null,
        "longitude": null,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "2017-09-28\r\n",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "388",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Elias Dadei",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tsavo West",
        "latitude": -0.562101,
        "longitude": 34.934856,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife species Sec 102 (1) (h) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "26-6-2017",
        "judgmentOutcome": "Accused acquited under Sec 215 CPC for lack of sufficient evidence",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "389",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Bernard Mwachofi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rekeke area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Matter withdrawn under sec 87 (a) CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Mzee Lemaita",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rekeke area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Matter withdrawn under sec 87 (a) CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Mutuku Musyia",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rekeke area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Matter withdrawn under sec 87 (a) CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "390",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Dawson Kirigha Kapanga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Tsavo West NP",
        "latitude": -3.020187,
        "longitude": 33.910819,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "8 kgs",
        "judgmentDate": 42968,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "391",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Stanley Kitolole",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "MWASHUMA",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "N/A",
        "weight": "750g",
        "judgmentDate": 42999,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "392",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Juma Nzau ",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Landi",
        "latitude": -1.304343,
        "longitude": 36.839071,
        "charge1": "Subsistence hunting Sec 97 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "2kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Case withdrawn under Sec. 89 (a) CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "393",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Yuakum Mwangazi",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Alia",
        "latitude": 1.726687,
        "longitude": 33.626908,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Python",
        "exhibit": "N/A",
        "weight": "13 feet",
        "judgmentDate": 42971,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "394",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Daniel Gichana ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Longoswa area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42990,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Paul Mingi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Longoswa area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42990,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "395",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Josphat Muluko Nyalo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Patmalo area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42951,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Patrick Muteti Musango",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Patmalo area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42951,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Patrick Muoki Mutisya",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Patmalo area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42951,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "396",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Joseph Moyio",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kajiado South",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42950,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Taiko Matasha ",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kajiado South",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42802,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Musembi Mwato",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kajiado South",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42802,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Parmtei Nyingi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kajiado South",
        "latitude": -1.842387,
        "longitude": 36.788914,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42802,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "397",
        "dateOfSeizure": "January-1900",
        "nameOfAccused": "Leku Ole Kuyan",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rombo",
        "latitude": -3.047226,
        "longitude": 37.694775,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lion",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42952,
        "judgmentOutcome": "Matter was withdrawn under  Section 87 of the CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "398",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Muley Muthoka",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Iserak",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik",
        "exhibit": "N/A",
        "weight": "30 kgs",
        "judgmentDate": 43011,
        "judgmentOutcome": "The chargesheet was amended to reflect the 3rd accused who had not absconded",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "399",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Luka Muthike",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mangula",
        "latitude": -3.515194,
        "longitude": 35.338017,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Giraffe, Gazelle",
        "exhibit": "N/A",
        "weight": "200 kgs giraffe meat; 50 kgs Gazelle",
        "judgmentDate": 42993,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "400",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Anthony Njenga Mumbora",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ilait market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Removing forest produce Sec 52 (1) (a) arw sec 52 FA ",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200 kgs",
        "judgmentDate": 43024,
        "judgmentOutcome": "Matter was withdrawn under Section 87 (a) of the CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Teresa Mbaaro ",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Ilait market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Removing forest produce Sec 52 (1) (a) arw sec 52 FA ",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sandalwood",
        "exhibit": "N/A",
        "weight": "200 kgs",
        "judgmentDate": 43024,
        "judgmentOutcome": "Matter was withdrawn under Section 87 (a) of the CPC",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "401",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Hamisi Karisa Hamisi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Katendewa area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Cheetah, Python",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42972,
        "judgmentOutcome": "Accused acquitted under Sec 215 of the CPC. The magistrate in this case was in the opinion that the prosecution did not measure up to the burden of proof.",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "402",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Jumaa Pola Kitsao Ngoa",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Giriama Ranch",
        "latitude": -3.8,
        "longitude": 39.5833,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Lesser Kudu",
        "exhibit": "N/A",
        "weight": "7 Kgs; 8kgs",
        "judgmentDate": 42775,
        "judgmentOutcome": "Accused sentenced to 200,000 i/d 1 year for each count",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "403",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Karabu Charo Mudako",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Giriama Ranch",
        "latitude": -3.8,
        "longitude": 39.5833,
        "charge1": "Possession of meat of wildlife species Sec 98 arw sec 105 WMCA",
        "charge2": "Possession of meat of wildlife species Sec 98 arw sec 105 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Dik-dik, Monkey",
        "exhibit": "N/A",
        "weight": "3 kgs; 1 kg",
        "judgmentDate": 42793,
        "judgmentOutcome": "Accused sentenced to serve 2 years probation on both counts",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "404",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "RamadhAN Mandaru Chiro",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kinango",
        "latitude": -4.138012,
        "longitude": 39.314922,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Eland",
        "exhibit": "N/A",
        "weight": "13 kgs",
        "judgmentDate": 42899,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "405",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Nickson Gona Kazungu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Muyeye area",
        "latitude": 0.989392,
        "longitude": 34.233214,
        "charge1": "Possession of wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 95 arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Sea turtle",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42782,
        "judgmentOutcome": "Matter withdrawn under Sec 25 of the the ODPP ACT. Letter sent by senior warden of Malindi Marine park to Prosecutor that the accused was more valuable as a witness since the he (the accused) is a crucial link to the arrest and prosecution of the main perpertraters",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "406",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Mohamed Masud",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Jambele Farm Area",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Hunting for bush meat trade Sec 97 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "19/1/2017",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "407",
        "dateOfSeizure": "January-2017",
        "nameOfAccused": "Robert Mariao Simat",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kanini Plaza within Nakuru County",
        "latitude": 0.186866,
        "longitude": 37.960968,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "3Kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "They should has discharged the accused on the second count as it’s a defective count",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "408",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "Paul Wambua Mutua",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kilili",
        "latitude": -1.878568,
        "longitude": 37.52319,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Blue Wildebeest",
        "exhibit": "N/A",
        "weight": 9,
        "judgmentDate": "N/A",
        "judgmentOutcome": "3 years probation",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "409",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "Aron Musembi Musyoki",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngokoni market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Possession of meat of wildlife species Sec 98 arw sec 92 WCMA",
        "charge2": "Dealing in meat of wildlife species Sec 98 arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "200kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "discharged under sec 87 (5) for a defective charge sheet.",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "Francis Kavoo Maweu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ngokoni market",
        "latitude": -0.100158,
        "longitude": 34.761953,
        "charge1": "Possession of meat of wildlife species Sec 98 arw sec 92 WCMA",
        "charge2": "Dealing in meat of wildlife species Sec 98 arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "200kgs",
        "judgmentDate": "N/A",
        "judgmentOutcome": "discharged under sec 87 (5) for a defective charge sheet.",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "410",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Lekayok Kiyok",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olomonjin",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "60 kgs",
        "judgmentDate": 42878,
        "judgmentOutcome": "The accused persons were given a probation penLty of one year which is not the set sentence for this offence.",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Kesiele Kiyok",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Olomonjin",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "60 kgs",
        "judgmentDate": 42878,
        "judgmentOutcome": "The accused persons were given a probation penLty of one year which is not the set sentence for this offence.",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "411",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Joseph Nyaga Ngungi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Muraru shopping centre",
        "latitude": 1.270062,
        "longitude": 34.698033,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Puff Adder",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42895,
        "judgmentOutcome": "Matter has been set for appeal",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "412",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "George Njeru Mutithi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Useini",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "120 kgs",
        "judgmentDate": "30/11/2017",
        "judgmentOutcome": "20 M i/d life imprisonment",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Abdi Ibrahim Harun",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Useini",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "Dealing in wildlife trophy Sec 84 (1) arw sec 92 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "120 kgs",
        "judgmentDate": "30/11/2017",
        "judgmentOutcome": "20 M i/d life imprisonment",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "413",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Makenye  Marwa Keruka",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": 42837,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Ibrahim Sifuti",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": 42837,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Nyanyi Kigwena",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": 42837,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Gakenye Mutonyi",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "20 kgs",
        "judgmentDate": 42837,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "414",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Samuel Zachria Ndakira",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Thompson Gazelle",
        "exhibit": "N/A",
        "weight": "40 kgs",
        "judgmentDate": 42866,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Sereria Mwikwabe Kisindikiza",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Thompson Gazelle",
        "exhibit": "N/A",
        "weight": "40 kgs",
        "judgmentDate": 42866,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "415",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Manga Mwita Matiko",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "25 kgs",
        "judgmentDate": 42870,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Petrol Maruba Musabi",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "25 kgs",
        "judgmentDate": 42870,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Manga Renya Muhere",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "25 kgs",
        "judgmentDate": 42870,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Murami Muhere Maruko",
        "nationality": "Tanzanian",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Possession of meat of wildlife speciesSec 98 WCMA",
        "charge3": "Unlawfull entry in Kenya C/S Sec 53 (2) Kenya Citizen and Immigration Act ",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Warthog",
        "exhibit": "N/A",
        "weight": "25 kgs",
        "judgmentDate": 42870,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "416",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Samwel Owira Juma",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge2": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "55 kgs",
        "judgmentDate": 42962,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Matthews Juma Masanga",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Maasai Mara Game Reserve",
        "latitude": -1.499819,
        "longitude": 33.808302,
        "charge1": "Possession of hunting apparatus Sec 102 (1) (f) WCMA",
        "charge2": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "55 kgs",
        "judgmentDate": 42962,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "417",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Benny Njogu Waweru",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Aberdare National Park",
        "latitude": 1.046528,
        "longitude": 34.282618,
        "charge1": "Logging in a National Park Sec 102 (1) (c) WCMA Sec 102 (1) (c) WCMA",
        "charge2": "Entry into a National Park C/S Sec 102 (1) (a) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "3/1/2017",
        "judgmentOutcome": "200,000 i/d 2 years for each count",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "418",
        "dateOfSeizure": "March-2017",
        "nameOfAccused": "Charles Gitari Kiboi",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Rumuruti",
        "latitude": 0.266798,
        "longitude": 36.53552,
        "charge1": "Logging in a National Park Sec 102 (1) (c) WCMA Sec 102 (1) (c) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "10/7/2017",
        "judgmentOutcome": " the cso to be served at Kirigo chiefs camp",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "419",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "James Lopua Kiama",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ol Maisor ranch ",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Impala",
        "exhibit": "N/A",
        "weight": "14kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "420",
        "dateOfSeizure": "June-2017",
        "nameOfAccused": "Shukri Kosi Duba",
        "nationality": "Kenyan ",
        "gender": "Male",
        "location": "Dirib Gombo area ",
        "latitude": -3.047226,
        "longitude": 37.694775,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Lesser Kudu",
        "exhibit": "N/A",
        "weight": "13kgs ",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "concluded "
    },
    {
        "no": "421",
        "dateOfSeizure": "November-2017",
        "nameOfAccused": "Jarso Halake ",
        "nationality": "Ethiopian",
        "gender": "Male",
        "location": "Dabaso Manyatta",
        "latitude": -0.10198,
        "longitude": 34.782951,
        "charge1": "Unlawfully present in Kenya Sec 53 (2) Immigration Act 2011",
        "charge2": "Possession of wildlife trophy Sec 95 WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Antelope",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "Withdrawn under Section 87 (a)",
        "sentencing": "N/A",
        "caseStatus": "concluded "
    },
    {
        "no": "422",
        "dateOfSeizure": "July-2017",
        "nameOfAccused": "John Lomunyin",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Ol Pejeta",
        "latitude": null,
        "longitude": null,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "Trespass upon Private Land Sec 3 (1) arw sec 11 Trespass Act",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Zebra",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42919,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "423",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Joseph Misugu",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Mt. Kenya National Park",
        "latitude": -1.26404,
        "longitude": 36.810033,
        "charge1": "Logging in a National Reserve Sec 102 (1) (c) WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Red Cedar",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42793,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "424",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "John Munuhe Ngure",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kagochi Village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "N/A",
        "weight": "60Kgs",
        "judgmentDate": 42986,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "August-2017",
        "nameOfAccused": "Isaiah Mathenge Mithamo",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Kagochi Village",
        "latitude": -2.292632,
        "longitude": 33.862182,
        "charge1": "Possession of meat of wildlife species Sec 98 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Waterbuck",
        "exhibit": "N/A",
        "weight": "60Kgs",
        "judgmentDate": 42986,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "425",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Beatrice Wairimu Mwai ",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Gakanga Area",
        "latitude": -0.938833,
        "longitude": 36.96354,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Logging in a National Park Sec 102 (1) (c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bamboo ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42795,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Grace Wairimu Thuku",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Gakanga Area",
        "latitude": -0.938833,
        "longitude": 36.96354,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Logging in a National Park Sec 102 (1) (c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bamboo ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42795,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Loice Watetu",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Gakanga Area",
        "latitude": -0.938833,
        "longitude": 36.96354,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Logging in a National Park Sec 102 (1) (c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bamboo ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42795,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "February-2017",
        "nameOfAccused": "Elizabeth Muthoni",
        "nationality": "Kenyan",
        "gender": "Female",
        "location": "Gakanga Area",
        "latitude": -0.938833,
        "longitude": 36.96354,
        "charge1": "Entry into a National Park Sec 102 (1) (a) WCMA",
        "charge2": "Logging in a National Park Sec 102 (1) (c) WCMA",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Bamboo ",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42795,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "426",
        "dateOfSeizure": "May-2017",
        "nameOfAccused": "Uwitonze Soizic",
        "nationality": "Rwandese",
        "gender": "Female",
        "location": "JKIA",
        "latitude": -1.765854,
        "longitude": 37.500305,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "11 worked out bangles",
        "weight": "N/A",
        "judgmentDate": 42958,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "427",
        "dateOfSeizure": "September-2017",
        "nameOfAccused": "Zhu Cheng Ping",
        "nationality": "Chinese",
        "gender": "Male",
        "location": "JKIA",
        "latitude": -1.765854,
        "longitude": 37.500305,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant ",
        "exhibit": "smoking pipe, 2 pendants and a bangle ",
        "weight": "N/A",
        "judgmentDate": 43006,
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "Concluded "
    },
    {
        "no": "428",
        "dateOfSeizure": "April-2017",
        "nameOfAccused": "Gilbert Mwambaji Mwambaji",
        "nationality": "Kenyan",
        "gender": "Male",
        "location": "Langata",
        "latitude": -3.677637,
        "longitude": 37.449945,
        "charge1": "Possession of wildlife trophy Sec 95 WCMA",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "Elephant",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": 42916,
        "judgmentOutcome": "Accused was acquited under section 215 cpc in court 7",
        "sentencing": "N/A",
        "caseStatus": "Concluded"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    },
    {
        "no": "N/A",
        "dateOfSeizure": "N/A",
        "nameOfAccused": "N/A",
        "nationality": "N/A",
        "gender": "N/A",
        "location": "N/A",
        "latitude": null,
        "longitude": null,
        "charge1": "N/A",
        "charge2": "N/A",
        "charge3": "N/A",
        "charge4": "N/A",
        "charge5": "N/A",
        "alternativeCharge1": "N/A",
        "alternativeCharge2": "N/A",
        "alternativeCharge3": "N/A",
        "species": "N/A",
        "exhibit": "N/A",
        "weight": "N/A",
        "judgmentDate": "N/A",
        "judgmentOutcome": "N/A",
        "sentencing": "N/A",
        "caseStatus": "N/A"
    }
]